export const zhCN = {
  'Finish now': '\u76f4\u63a5\u5b8c\u6210',
  'Spelling': '\u62fc\u5199',
  'LexiLamp': '词源通',
  'Audio could not be prepared': '音频暂时无法准备。',
  'Audio text is required': '请输入音频文本。',
  'This reading could not be opened.': '暂时无法打开这套阅读，请稍后重试。',
  'Choose vocabulary scope': '选择词汇范围',
  'Recent words': '最近单词',
  "Today's words": '今日单词',
  'Last study session': '上次学习',
  'Uses your recent learning and review history.': '使用最近的学习与复习记录。',
  'Uses words learned or reviewed today.': '只使用今天学习或复习过的词。',
  'Uses the exact words and exercises from your most recent completed session.': '使用最近一次完整学习中的词汇和练习记录。',
  'IELTS simulation': '雅思模拟',
  'Adaptive practice': '自适应练习',
  'Adaptive Reading': '自适应阅读',
  'Targets your vocabulary, sentence-ordering errors, and current learning level.': '结合所选词汇、句子重组错误和当前学习水平进行针对性练习。',
  'Generate adaptive practice': '生成自适应练习',
  'Generate IELTS simulation': '生成雅思模拟',
  'Learning complete': '学习完成',
  'Choose what to practise next.': '选择接下来要做的练习。',
  'Reading practice': '阅读练习',
  'Dictation': '听写',
  'Create a reading from the words and exercises in this session.': '根据本次学习的词汇和练习生成阅读。',
  'Check spelling and match each word to its meaning.': '检查拼写，并为每个单词选出对应词义。',
  'Reading will open first, followed by dictation with the same words.': '将先进行阅读，再用同一批词进行听写。',
  'Start reading, then dictation': '先阅读，再听写',
  'Start reading': '开始阅读',
  'Start dictation': '开始听写',
  'Continue to dictation': '继续听写',
  'The saved dictation set is no longer available. Choose the words again below.': '上次保存的听写词单已失效，请在下方重新选择。',
  'This reading is built from the vocabulary, exercises, errors, and hints in the study session you just completed.': '这套阅读会使用你刚完成的这轮学习中的词汇、练习、错误和提示。',
  'Create a reading from this session': '根据本轮学习生成阅读',
  'Available to students': '已可供学生学习',
  'Meanings available to students': '已可供学生学习的词义',
  "Each meaning appears in the student's task as soon as its essential practice is ready.": '每个词义的基础练习准备好后，就会立即出现在学生任务中。',
  'Preparing ready-to-learn practice': '正在准备可学习的练习',
  'Filter words': '筛选词汇',
  'Filter words you already know': '筛掉已经会的词',
  'All words are already completed': '这本词库已经全部完成',
  'Back to Word Overview': '返回单词总览',
  'Quick progress cleanup': '快速清理学习进度',
  'Quickly remove words you already know from the learning queue. You have five seconds for each four-choice meaning question.': '快速筛掉你本来就会的词。每题有 5 秒，从四个意思中选出正确答案。',
  'Quickly remove words you already know from the learning queue. You have seven seconds for each four-choice meaning question.': '快速筛掉你本来就会的词。每题有 7 秒，从四个意思中选出正确答案。',
  'Words in this wordbook': '词库总词数',
  'Already completed': '已经完成',
  'Ready to filter': '等待筛选',
  'What happens when you answer correctly?': '答对后会发生什么？',
  'The word is marked as learned and all eight reviews are completed. Wrong, unknown, and timed-out words stay in your learning queue.': '这个词会直接标记为已学会，并完成全部 8 次复习；答错、不认识或超时的词仍保留在学习队列中。',
  'Not now': '暂不筛选',
  'Start filtering': '开始筛选',
  'Preparing your word filter...': '正在准备词汇筛选…',
  'Loading the next words...': '正在载入下一批单词…',
  'Word filter could not start': '无法开始词汇筛选',
  'Failed to load word filter.': '无法载入词汇筛选。',
  'Could not check this answer.': '暂时无法检查这个答案。',
  'Filtering complete': '筛选完成',
  'This wordbook is already complete': '这本词库已经全部完成',
  'Your progress now reflects what you already knew.': '现在的进度已经计入你原本就会的单词。',
  'There are no unmastered words to filter right now.': '目前没有尚未掌握的词需要筛选。',
  'Filtered as known': '筛选为已掌握',
  'Still worth learning': '仍值得学习',
  'Remaining in this wordbook': '词库剩余',
  'Filter the remaining words again': '再次筛选剩余单词',
  'Exit filter': '退出筛选',
  'Choose the best meaning': '选择最合适的意思',
  'Which meaning fits this word?': '这个词最符合哪一个意思？',
  "I don't know this word": '我不认识这个词',
  'Checking...': '正在检查…',
  'Known word cleared. All reviews completed.': '已筛掉这个熟词，并完成全部复习。',
  'Not cleared. Correct meaning:': '没有筛掉。正确意思：',
  'Time is up. Kept for learning:': '时间到，保留学习：',
  'Kept for learning:': '保留学习：',
  'Self Check': '自我检测',
  'More experiments': '更多实验功能',
  'Explore new ways to practise with your learning history.': '使用你的学习记录，探索新的练习方式。',
  'Available experiments': '可用实验：{count} 项',
  'Open': '进入',
  'Experimental practice': '实验练习',
  'Adaptive IELTS-style Reading': '自适应雅思风格阅读',
  'Turn recent vocabulary and sentence difficulties into a fresh 20-minute reading.': '用近期词汇和句子重组难点，生成一套全新的 20 分钟阅读练习。',
  'Open experiment': '进入实验',
  'Back to Self Check': '返回自我检测',
  'A fresh 20-minute passage built around your recent vocabulary, review history, and sentence-ordering difficulties.': '围绕你最近学习和复习的词汇，以及句子重组中的难点，生成一套全新的 20 分钟阅读。',
  'Private practice only. This is IELTS-style training, not an official IELTS score.': '仅用于个人练习。这是雅思风格训练，不是官方雅思成绩。',
  'Reading your recent learning history...': '正在整理近期学习记录……',
  'Vocabulary pool': '候选词汇',
  'History window': '参考记录范围',
  'days': '天',
  'Recent accuracy': '近期正确率',
  'Choose a practice mode': '选择练习模式',
  'Full mock': '真实模考',
  'Custom practice': '定制练习',
  'Closely follows IELTS Academic reading structure, pacing, and question standards.': '尽量复刻雅思学术类阅读的结构、节奏和出题标准。',
  'Targets your recent vocabulary, sentence-ordering errors, and current learning level.': '重点针对近期词汇、句子重组错误和当前学习档位。',
  'Complete a little more vocabulary practice before generating this reading.': '再完成一些词汇练习后，就可以生成这套阅读。',
  'Generate a 20-minute reading': '生成 20 分钟阅读',
  'Generate full mock': '生成真实模考',
  'Generate custom practice': '生成定制练习',
  'Recent adaptive readings': '最近的自适应阅读',
  'Continue reading': '继续作答',
  'Preparing your adaptive reading': '正在准备自适应阅读',
  'Selecting useful recent vocabulary': '正在挑选近期值得巩固的词汇',
  'Writing a coherent academic passage': '正在组织连贯的学术风格文章',
  'Building IELTS-style questions': '正在编写雅思风格题目',
  'Checking every answer against the passage': '正在逐题核对文章依据',
  'The passage is saved before you begin, so it can be resumed later.': '文章生成后会自动保存，中途离开也可以继续。',
  'Type your answer': '输入答案',
  'True': '正确',
  'False': '错误',
  'Not given': '未提及',
  'answered': '题已作答',
  'multiple choice': '选择题',
  'true false not given': '判断题',
  'sentence completion': '句子填空',
  'Review later': '稍后检查',
  'Some questions are unanswered. Submit anyway?': '还有题目未作答，仍然提交吗？',
  'Reviewing your result...': '正在整理结果……',
  'Submit reading': '提交阅读',
  'Adaptive reading result': '自适应阅读结果',
  'Reading score': '阅读得分',
  'AI coaching review': 'AI 学习建议',
  'What went well': '表现较好的方面',
  'Next practice focus': '下一步练习重点',
  'Performance estimate': '本次表现估计',
  'Learning observation': '学习观察',
  'Review every answer': '逐题回顾',
  'Your answer': '你的答案',
  'Correct answer': '正确答案',
  'Evidence': '文章依据',
  'Why': '解析',
  'Create another reading': '再生成一套阅读',
  'Could not read your learning history': '暂时无法读取你的学习记录',
  'Could not open this reading': '暂时无法打开这套阅读',
  'This reading could not be prepared yet. Please try again.': '这套阅读暂时未能生成，请稍后重试。',
  'Your reading could not be submitted': '这套阅读暂时未能提交，请重试。',
  'Reading not found': '没有找到这套阅读',
  'Independent practice': '自主练习',
  'Turn the words you just studied into a focused test. Practice until recall is secure, without changing your formal progress unless you choose to.': '把刚学过的单词变成一次专注自测。练到真正记牢；除非你主动选择，否则不会改变正式学习进度。',
  'Build your set': '准备词单',
  'What do you want to check today?': '今天想检查哪些单词？',
  'Paste a list or bring back words from your own study history. You can edit everything before starting.': '可以粘贴词单，也可以从自己的学习记录中快速取词；开始前都能自由编辑。',
  'Study date': '学习日期',
  'Add learned words': '加入当天新学词',
  'Add reviewed words': '加入当天复习词',
  'Add due reviews': '加入到期复习词',
  'available': '个可用',
  'Your word list': '你的词单',
  'One word or phrase per line': '每行一个单词或短语',
  'Choose a test mode': '选择测试模式',
  'Recent self-checks': '最近自测',
  'Recording saved': '录音已保存',
  'View result and recording': '查看结果和录音',
  'Loading recording...': '正在加载录音…',
  'The IELTS speaking attempt was not found.': '未找到这次雅思口语练习。',
  'words': '个单词',
  'ready': '个已就绪',
  'Edit word list': '编辑词单',
  'Choose how to test yourself': '选择你的自测方式',
  'These results are private practice records and do not change your formal learning progress.': '这些结果只记入个人练习记录，不会改变正式学习进度。',
  'Not found and skipped:': '未找到并已跳过：',
  'Dictation Loop': '循环听写',
  'Hear the word, spell it, and repeat only missed words until every spelling is secure.': '听发音并拼写；每轮只重做错词，直到全部拼对。',
  'Accuracy over speed': '准确优先',
  '5-Second Meaning': '五秒辨义',
  '7-Second Meaning': '七秒辨义',
  'Match each word to its meaning within five seconds. Missed words return in the next round.': '在五秒内选出词义；错词会进入下一轮，直到全部答对。',
  'Match each word to its meaning within seven seconds. Missed words return in the next round.': '在七秒内选出词义；错词会进入下一轮，直到全部答对。',
  'First-pass accuracy': '首轮正确率',
  'Lightning Challenge': '闪电挑战',
  'The clock falls from five seconds toward two. One miss ends the run. How long can you hold on?': '答题时间会从五秒逐渐降到两秒；一次失误即结束，看看你能坚持多久。',
  'Best streak': '最佳连胜',
  'Hear the word, spell it, then choose its definition. Only missed words return in the next round.': '听到单词后完成拼写并选择对应词义；只有错词会进入下一轮。',
  'Spelling and meaning': '拼写与词义',
  'Round': '轮次',
  'Replay word': '重播单词',
  'Type what you hear': '输入你听到的单词',
  'Check spelling': '检查拼写',
  'Correct': '正确',
  'Look closely, then try it again next round.': '仔细看清差异，下一轮再把它拼对。',
  'Correct spelling:': '正确拼写：',
  'Continue': '继续',
  'Streak': '连胜',
  'Choose the closest meaning': '选择最接近的意思',
  'Time is up': '时间到',
  'Not this one': '不是这个',
  'Self-check complete': '自测完成',
  'Saving result...': '正在保存结果……',
  'Saved to your private practice history': '已保存到个人练习记录',
  'First pass': '首轮',
  'Time': '用时',
  'Rounds': '轮次',
  'Average response': '平均反应',
  'Words checked': '检测词数',
  'Words worth another look': '值得再看一遍的词',
  'Clean run': '一次全对',
  'You cleared every word without a first-pass miss.': '所有单词首轮全部通过。',
  'All words passed': '全部通过',
  'You passed every word after another round of practice.': '经过再次练习，所有单词均已通过。',
  'Retry missed words': '重测错词',
  'Restart challenge': '重新挑战',
  'Repeat full test': '重新完整测试',
  'Back to word selection': '返回选词页',
  'Add missed words to learning': '把错词加入学习',
  'New self-check': '新建自测',
  'Missed words added to your learning queue.': '错词已加入学习队列。',
  'Could not load study history': '无法加载学习记录',
  'Could not prepare this word set': '无法准备这份词单',
  'None of these words were found in the dictionary': '词典中没有找到这些单词',
  'The result could not be saved, but your summary is still available here.': '结果暂时未能保存，但本页总结仍然可用。',
  'Learning level': '学习等级',
  'Default practice level': '默认练习等级',
  'Teacher baseline:': '教师设定的起点：',
  'Minimum Learning Level': '最低学习等级',
  'Minimum learning level': '最低学习等级',
  'Login response was incomplete. Please try again.': '登录响应不完整，请重试。',
  'Lexilab': '词源通', 'LexiLab': '词源通',
  'Learn smarter. Practice better. Grow faster.': '更聪明地学习，更有效地练习，更稳步地成长。',
  'Unable to reach LexiLamp. Please use ciyuantong.com and try again.': '暂时无法连接词源通，请使用 ciyuantong.com 后重试。',
  'The service is temporarily unavailable. Please try again shortly.': '服务暂时不可用，请稍后重试。',
  'Signing in…': '正在登录…',
  'Dashboard': '首页', 'Home': '首页', 'Menu': '菜单', 'Platform Overview': '平台总览',
  'Admin Dashboard': '教师中心', 'Superadmin': '超级管理员', 'Student Center': '学生中心',
  'My Profile': '我的资料', 'Word Practice': '单词练习', 'Word Overview': '单词总览',
  'Quiz List': '测验列表', 'My Wordbooks': '我的词库', 'My Bookmarks': '我的收藏',
  'Progress Tracker': '学习进度', 'Review': '复习', 'Quizzes': '测验', 'Dictionary': '词典',
  'Wordbooks': '词库', 'Pending Teachers': '待审核教师', 'Secret Wordbook Box': '私密词库箱',
  'Help Center': '帮助中心', 'Platform Manual': '平台手册', 'Ask the AI assistant': '询问 AI 客服',
  'A bilingual guide for students, teachers, and support replies. Use it to find the right button, page, and workflow.': '面向学生、老师和客服回复的双语指南，可用来查找按钮、页面和流程。',
  'Ask where to click, how a workflow works, or what a result means. The assistant answers from the platform manual.': '可以询问该点哪里、流程怎么走、结果是什么意思。AI 客服会根据平台手册回答。',
  'Refresh manual': '刷新手册', 'Open Markdown': '打开 Markdown',
  'What do you need help with?': '你需要什么帮助？',
  'For example: How does a teacher assign words to one student?': '例如：老师怎样给单个学生分配单词？',
  'Ask AI': '问 AI', 'Asking...': '正在询问…', 'AI answer': 'AI 回答',
  'Manual': '手册', 'Browse the full guide': '浏览完整指南',
  'Loading manual...': '正在加载手册…',
  'Manual is temporarily unavailable.': '手册暂时不可用。',
  'The help assistant could not answer right now.': 'AI 客服暂时无法回答。',
  'The help assistant is busy right now. Please try again in a moment.': 'AI 客服现在有点忙，请稍后再试。',
  'The help assistant is temporarily unreachable.': 'AI 客服暂时连接不上。',
  'The help assistant has reached today’s usage limit. Please try again tomorrow.': 'AI 客服今天的使用次数已达上限，请明天再试。',
  'AI Help': 'AI 客服', 'Ask about any page or workflow': '询问任何页面或操作流程',
  'New chat': '新对话', 'Clear conversation': '清空对话', 'How can I help?': '有什么可以帮你？',
  'Ask where to click, how a workflow works, or what a result means.': '可以问我该点哪里、流程怎么走，或某项结果是什么意思。',
  'How do I assign words to one student?': '怎样给单个学生分配单词？',
  'Where can I see today’s student practice?': '在哪里查看学生今天的练习？',
  'How do assignment deadlines work?': '分配单词的截止日期怎样计算？',
  'How do I start today’s assignment?': '怎样开始今天的老师布置任务？',
  'Where can I review my words?': '在哪里复习我的单词？',
  'What do the four practice steps mean?': '四步练习分别是什么意思？',
  'Thinking': '正在思考', 'Message AI Help': '向 AI 客服提问', 'Send': '发送',
  'AI Help answers from the platform guide. Check important details before acting.': 'AI 客服根据平台指南回答；重要操作请确认后再进行。',
  'Logout': '退出登录', 'Sign In': '登录', 'Username': '用户名', 'Password': '密码',
  'Create Account': '创建账户', 'Don’t have an account?': '还没有账户？',
  'Learn smarter. Practice better. Grow faster.': '更聪明地学习，更有效地练习，更稳步地成长。',
  'Super Admin Login': '超级管理员登录', 'Open navigation': '打开导航', 'Close navigation': '关闭导航',
  'English': 'English', 'Simplified Chinese': '简体中文', 'Language': '语言',

  'Loading...': '加载中…', 'Loading…': '加载中…', 'Loading words...': '正在加载单词…',
  'Loading students...': '正在加载学生…', 'Loading student list...': '正在加载学生列表…',
  'Loading quizzes...': '正在加载测验…', 'Loading Quiz...': '正在加载测验…',
  'Loading results...': '正在加载结果…', 'Loading history...': '正在加载历史记录…',
  'Loading attempt history...': '正在加载作答历史…', 'Loading submission history...': '正在加载提交历史…',
  'Loading bookmarks...': '正在加载收藏…', 'Loading review...': '正在加载复习内容…',
  'Loading review history...': '正在加载复习记录…', 'Loading your study data...': '正在加载你的学习数据…',
  'Loading pre-test...': '正在加载预检…', 'Loading next round...': '正在加载下一轮…',
  'Initializing...': '正在初始化…', 'Preparing plan…': '正在准备计划…',
  'Preparing practice...': '正在准备练习…', 'Please wait, this may take a moment.': '请稍候，这可能需要一点时间。',
  'Finalizing and saving your results...': '正在整理并保存结果…',
  'Scoring your sentences with AI...': 'AI 正在为你的句子评分…', 'Searching...': '正在搜索…',
  'Speaking…': '正在朗读…',

  'Add': '添加', 'Edit': '编辑', 'Delete': '删除', 'Remove': '移除', 'Rename': '重命名',
  'Save': '保存', 'Cancel': '取消', 'Close': '关闭', 'Back': '返回', 'Next': '下一步',
  'Previous': '上一步', 'Done': '完成', 'Confirm': '确认', 'Accept': '接受', 'Decline': '拒绝',
  'Select': '选择', 'Select all': '全选', 'Clear selection': '清除选择', 'Search': '搜索',
  'Refresh': '刷新', 'Generate': '生成', 'Regen': '重新生成', 'Preview': '预览',
  'Import': '导入', 'Publish': '发布', 'Unpublish': '取消发布', 'Manage': '管理',
  'Actions': '操作', 'Action': '操作', 'Status': '状态', 'Type': '类型', 'Name': '名称',
  'Date': '日期', 'Time': '时间', 'Role': '角色', 'Tier': '等级', 'Items': '项目',
  'Score': '分数', 'Score:': '分数：', 'Progress': '进度', 'Overview': '总览',
  'Completed': '已完成', 'Completed:': '已完成：', 'Incomplete:': '未完成：',
  'Pending': '待处理', 'Published': '已发布', 'Draft': '草稿', 'Drafts': '草稿',
  'Private': '私有', 'Locked': '已锁定', 'Passed': '已通过', 'Failed': '未通过',
  'Learned': '已学习', 'Reviewed': '已复习', 'Created': '已创建',
  'None': '无', '(None)': '（无）', '(Unavailable)': '（不可用）', '(Assigned)': '（已分配）',

  'Quick Actions': '快捷操作', 'Welcome back! Quickly view today’s goals and review status here.': '欢迎回来！在这里快速查看今天的目标和复习状态。', 'Today’s Status': '今日状态',
  'Welcome to your vocabulary plan': '欢迎来到你的词汇学习计划', 'What to learn today?': '今天学什么？',
  'Choose a mode to start your learning journey.': '选择一种模式，开始今天的学习。',
  'Please choose your learning mode.': '请选择学习模式。', 'Learn new words': '学习新词',
  'Review old words': '复习旧词', 'One-click Review': '一键复习', 'Start Learning': '开始学习',
  'Start Review': '开始复习', 'Practice Session': '练习环节', 'Practice complete!': '练习完成！',
  'Learning Complete': '学习完成', 'Review Done': '复习完成', 'Pre-test': '预检',
  'Pre-test Complete': '预检完成', 'Today’s Status': '今日状态', 'To-Do': '待完成',
  'Daily learning goal': '每日学习目标', 'Daily goal (words)': '每日目标（词）',
  'Update Goal': '更新目标', 'Current streak': '当前连续天数', 'Max Streak (days)': '最长连续天数',
  'Consecutive days achieved:': '已连续达成：', 'days': '天', 'Reviewed Today': '今日已复习',
  'Words Learned': '已学单词', 'Words Learned:': '已学单词：', 'Words Reviewed': '已复习单词',
  'Words Reviewed:': '已复习单词：', 'new words': '个新词', 'to review': '个待复习',
  'Daily Study Log (last 30 days)': '每日学习记录（近 30 天）',
  'View all learned words': '查看所有已学单词',
  'All learned words': '所有已学单词',
  '{count} unique words across {days} learning days': '共 {count} 个不重复单词，分布在 {days} 个学习日',
  '{count} words': '{count} 个单词',
  'Words are grouped by their first recorded learning date.': '单词按首次记录的学习日期分组。',
  'Copy dated list': '复制带日期词表',
  'Copying...': '正在复制…',
  'Copy failed': '复制失败',
  'Everything is firmly remembered — proud of you!': '所有单词都记牢了，为你骄傲！',
  'Great job! Keep it up!': '做得很好，继续保持！',
  'You’ve completed all assigned tasks. Great discipline!': '你已经完成所有任务，自律得很棒！',
  'No reviews today!': '今天没有待复习内容！', 'No upcoming reviews.': '暂无即将到来的复习。',
  'Daily Review': '每日复习', 'Daily review goal': '每日复习目标',
  'Custom review': '自选复习', 'Choose learned meanings by date, then start the same review exercises.': '按学习日期选择已学词义，然后使用同样的复习练习。', 'Close custom review': '关闭自选复习',
  'Search learned meanings': '搜索已学词义', 'Search by English word or Chinese meaning': '按英文单词或中文释义搜索', 'Select visible': '选择当前结果', 'Clear visible': '清除当前结果',
  '{count} selected': '已选择 {count} 个', 'Maximum {count} meanings per custom review.': '每次自选复习最多 {count} 个词义。', 'You can select up to {count} meanings at a time.': '一次最多选择 {count} 个词义。', 'Select at least one meaning to start custom review.': '请至少选择一个词义后开始自选复习。',
  'Custom review candidates could not be loaded.': '暂时无法加载自选复习词义。', 'Loading learned meanings...': '正在加载已学词义……', 'No learned meanings are available for custom review.': '暂无可用于自选复习的已学词义。', 'No results match your search.': '没有符合搜索条件的结果。',
  'Learned {date} · {count} meanings': '{date} 学习 · {count} 个词义', 'Unknown learning date · {count} meanings': '学习日期未知 · {count} 个词义', 'Select all meanings learned {date}': '选择 {date} 学习的全部词义', 'on an unknown date': '未知日期',
  'Meaning unavailable': '暂无释义', 'Due': '到期', 'Extra practice': '额外练习', 'Next review {date}': '下次复习：{date}', 'Additional meaning': '其他词义',
  'Start custom review': '开始自选复习', 'Due meanings count toward today’s review. Extra practice meanings do not change their original review schedule.': '到期词义会计入今日复习；额外练习不会改变原有复习安排。',
  'Custom review completed: {count}/{total} selected meanings.': '自选复习完成：已完成所选 {count}/{total} 个词义。', '{count} due meanings counted toward today’s review; {extra} were extra practice.': '其中 {count} 个到期词义计入今日复习，{extra} 个为额外练习。', 'Extra practice meanings keep their original review schedule.': '额外练习词义会保留原有复习安排。',
  'Choose specific meanings instead': '改为选择具体词义', 'Custom review could not be saved. Please try again.': '无法保存自选复习选择，请重试。', 'Custom review selection is missing. Choose the meanings again.': '自选复习选择已丢失，请重新选择词义。', 'Custom review selection is empty. Choose the meanings again.': '自选复习没有选择词义，请重新选择。', 'The selected meanings were not available. Please retry custom review.': '所选词义暂时不可用，请重试自选复习。', 'Your custom review selection could not be restored. Choose the meanings again to continue.': '无法恢复自选复习选择，请重新选择词义后继续。',
  'No review due today': '今天没有复习任务', 'All due reviews completed': '今日到期内容已全部完成',
  'Daily review goal met': '今日复习目标已达到', 'Reviews today': '今日复习',
  '{done}/{goal} meanings completed': '已完成 {done}/{goal} 个词义',
  '{count} meanings in review queue': '复习队列中还有 {count} 个词义',
  'Daily review goal met · {count} still available': '今日复习目标已达到 · 队列仍有 {count} 个',
  'Review {remaining} more today · {count} in queue': '今天再复习 {remaining} 个 · 队列共 {count} 个',
  'Enter a daily goal between 1 and 500.': '请输入 1 到 500 之间的每日目标。',
  'Could not save the review goal.': '暂时无法保存复习目标。',
  'Lower goals start tomorrow. A higher goal can apply today.': '降低目标从明天生效；提高目标可立即用于今天。',
  'Meanings in this review': '本次复习词义数',
  'This round completed {count} meanings.': '本轮完成 {count} 个词义。',
  'Today’s goal is complete. {count} meanings remain in the queue.': '今日目标已达到，队列还剩 {count} 个词义。',
  '{remaining} more to reach today’s goal. {count} meanings remain in the queue.': '再完成 {remaining} 个即可达到今日目标，队列还剩 {count} 个词义。',
  'Today: {done}/{goal}': '今日：{done}/{goal}', 'Review more': '继续复习',
  'Temporarily finish': '暂时结束', 'Open word overview': '返回学习概览',
  'How many meanings to review?': '本次复习多少个词义？',
  'This changes only this batch, not your daily goal.': '这里只调整本轮数量，不会改变每日复习目标。',
  'No new words!': '没有新词！',

  'Foundation': '基础', 'Starter': '起步', 'Bridge': '衔接', 'Core': '核心',
  'Advanced': '进阶', 'Challenge': '挑战', 'Building confidence': '建立信心',
  'Finding their footing': '渐入佳境', 'Finding momentum': '稳步提升',
  'Growing steadily': '持续成长', 'Advancing strongly': '进阶有力', 'Ready to excel': '蓄势突破',
  'Chinese-supported contexts': '中文辅助语境', 'Simple English clues': '简单英语线索',
  'Clear everyday English': '清晰的日常英语', 'Richer real-world English': '更丰富的真实语境',
  'Academic reading practice': '学术阅读练习', 'SAT-style depth': 'SAT 风格深度',
  'Benefits from familiar contexts and guided support.': '适合通过熟悉语境和引导支持来学习。',
  'Ready to learn new words through clear, familiar English.': '已准备好通过清晰熟悉的英语学习新词。',
  'Ready to build fluency through junior-high reading contexts.': '已准备好通过初中阅读语境建立流利度。',
  'Developing confidence with senior-high and early CET material.': '正在高中及大学英语基础材料中建立信心。',
  'Ready for DSE and TOEFL-style language and structure.': '已准备好应对 DSE 与托福风格的语言和结构。',
  'Thrives on the most demanding vocabulary and reasoning tasks.': '能够胜任高难度词汇与推理任务。',
  'Learning Level': '学习等级', 'Learning level:': '学习等级：', 'Choose difficulty': '选择难度', 'Choose difficulty and amount': '选择难度和学习数量',
  'Choose difficulty to start review.': '选择难度后开始复习。',
  'Choose quantity and difficulty before starting.': '开始前请选择数量和难度。',
  'How many to study this time?': '这次学习多少个？', 'Tip: Start with 10 and adjust as needed.': '建议先从 10 个开始，再按需要调整。',

  'Word': '单词', 'Word:': '单词：', 'Definition': '释义', 'Def': '释义', 'Meaning:': '含义：',
  'English definition': '英文释义', 'English definition:': '英文释义：', 'Chinese definition': '中文释义',
  'Chinese definition:': '中文释义：', 'Chinese Meaning:': '中文含义：', 'English:': '英文：', 'Chinese:': '中文：',
  'POS:': '词性：', 'Word root': '词根', 'Word root:': '词根：', 'Examples:': '例句：',
  'Example Sentences:': '例句：', 'Sample sentences': '示例句', 'Exercises': '练习', 'Exercises:': '练习：',
  'Explanation': '讲解', 'Feedback:': '反馈：', 'AI Feedback:': 'AI 反馈：',
  'In this sentence, what does the highlighted word mean?': '在这个句子中，高亮单词是什么意思？',
  'Reorder the following sentence:': '请重新排列下面的句子：',
  'Join': '连接',
  'Join these chunks': '连接这两个语块',
  'Join {left} and {right}': '连接 {left} 和 {right}',
  'Split this chunk': '拆开这个语块',
  'Disconnect these words': '断开这组单词',
  'Disconnect {left} and {right}': '断开 {left} 和 {right}',
  'Drag {chunk}': '拖动 {chunk}',
  'Drop at position {position}': '放到第 {position} 个位置',
  'Unused words': '待使用单词',
  'Split {left} and {right}': '拆开 {left} 和 {right}',
  'Return this chunk to the word bank': '将这个语块放回选项区',
  'Sentence Reordering Explanation': '句子重排讲解', 'Build your sentence here...': '在这里写出你的句子…',
  'Correct!': '正确！', 'Correct Answer': '正确答案', 'Correct Answer:': '正确答案：',
  'Meaning Match': '近义匹配',
  'Which word best matches?': '哪个词最贴近高亮部分的意思？',
  'Choose the word that best captures the highlighted meaning. The sentence may use a different form or structure.': '选择最能表达高亮部分意思的单词；原句的词形或句式可能不同。',
  'Best match:': '最佳匹配：',
  'Natural rewrite:': '自然改写：',
  'Correct Spelling:': '正确拼写：', 'Your answer:': '你的答案：', 'Student Answer': '学生答案',
  'Question:': '题目：', 'Blank': '空格', 'Sentence': '句子',
  'Familiarize yourself with the following words and their meanings.': '熟悉下列单词及其含义。',
  'Use the word bank below to complete each sentence.': '请使用下方词库完成每个句子。',
  'Create a unique sentence for each of the following words.': '请为下面每个单词分别造句。',
  'Invalid practice stage.': '无效的练习阶段。', 'Start Dictation': '开始听写',
  'Start dictation practice to reinforce spelling?': '开始听写练习来巩固拼写吗？',
  'Hint Mode': '提示模式', 'Direct Mode': '直接模式',

  'Class Management': '班级管理', 'Class Overview': '班级总览', 'Class Statistics': '班级统计',
  'Class': '班级', 'Classes:': '班级：', 'My Classes': '我的班级', 'Create Class': '创建班级',
  'Back to Class': '返回班级', 'This class has no students yet.': '这个班级暂时没有学生。',
  'No classes': '暂无班级', 'No classes found.': '未找到班级。',
  'No classes yet. Create or join a class first.': '暂无班级，请先创建或加入班级。',
  'Student Management': '学生管理', 'Student Details': '学生详情', 'Student Data': '学生数据',
  'Student': '学生', 'Linked Students': '已关联学生', 'Number of Students': '学生人数',
  'Add Students to Class': '向班级添加学生', 'Invite students': '邀请学生',
  'Invite Students to Class': '邀请学生加入班级', 'Search Students and Send Invites': '搜索学生并发送邀请',
  'No students in this class.': '班级中暂无学生。', 'No students available to invite.': '暂无可邀请的学生。',
  'No linked students. Send invites and they’ll appear here after acceptance.': '暂无关联学生；邀请被接受后会显示在这里。',
  'Pending Teacher Approvals': '待审核教师', 'No pending teacher accounts.': '暂无待审核教师账户。',
  'No pending invites for students.': '暂无待处理的学生邀请。', 'Sent Invites': '已发送邀请',
  'Status: Awaiting student confirmation': '状态：等待学生确认', 'Direct Login (Impersonate)': '直接登录（代入账户）',
  'Logs in as the specified account and redirects to its dashboard.': '以指定账户登录并跳转到其首页。',
  'Create New Student Account': '创建学生账户', 'Create Student Account': '创建学生账户',
  'Create student': '创建学生', 'Create New Student': '创建学生', 'Student Username Prefix': '学生用户名开头',
  'Only username and password required.': '只需填写用户名和密码。',
  'Note: Newly created students have default password 123456.': '注意：新建学生的默认密码为 123456。',
  'Note: Bulk-created students have default password 123456.': '注意：批量创建学生的默认密码为 123456。',
  'Bulk import': '批量导入', 'Bulk Import Students': '批量导入学生', 'Upload CSV or XLSX': '上传 CSV 或 XLSX',
  'Upload CSV/XLSX': '上传 CSV/XLSX', 'Import Complete!': '导入完成！', 'Invalid rows:': '无效行：',

  'Vocabulary Management': '词汇管理', 'Vocabulary Stats': '词汇统计', 'Add Word': '添加单词',
  'AI Generated Vocabulary': 'AI 生成词汇', 'Please review the generated word': '请检查生成的单词内容',
  'Enter an English word; AI will automatically generate its definition, examples, and exercises for your review before adding it to the database.': '输入英文单词；AI 会自动生成释义、例句和练习，供你检查后加入数据库。',
  'Generated Items Preview': '生成内容预览', 'Confirm & Generate': '确认并生成',
  'All Word Lists': '所有词表', 'Word List': '词表', 'Manage Word Lists': '管理词表',
  'Create New List': '创建新词表', 'Word (A-Z)': '单词（A-Z）', 'Filter by tag': '按标签筛选',
  'Search words': '搜索单词', 'No matching words': '没有匹配的单词', 'No words.': '暂无单词。',
  'No words yet': '暂无单词', 'Number of Words': '单词数量', 'Show Used Words': '显示已使用单词',
  'Mark New': '标为新词', 'Mark Used': '标为已使用', 'Already exist (skipped):': '已存在（已跳过）：',
  'Non-letter characters are ignored; duplicates removed automatically.': '非字母字符会被忽略，重复项会自动移除。',

  'Manage My Wordbooks': '管理我的词库', 'Create New Wordbook': '创建新词库', 'Create wordbook': '创建词库',
  'Create one': '创建一个', 'Create Private Wordbook': '创建私人词库', 'Create Secret Wordbook': '创建私密词库',
  'Wordbook title': '词库标题', 'Wordbook title (optional)': '词库标题（可选）', 'Wordbook name': '词库名称',
  'Select wordbook': '选择词库', 'Select wordbooks': '选择词库', 'Please choose a wordbook': '请选择词库',
  'Priority wordbook': '优先词库', 'Priority wordbook (optional)': '优先词库（可选）',
  'Teacher-assigned words (priority)': '教师分配单词（优先）', 'No priority (teacher assignments only)': '不设优先级（仅教师分配）',
  'Tracked Wordbooks': '已追踪词库', 'All Wordbooks': '全部词库', 'All': '全部', 'Manage Tracked Wordbooks': '管理追踪词库',
  'Overall Progress': '总体进度', 'Overall Progress ({scope})': '总体进度（{scope}）',
  'Review progress': '复习进度', 'Mastered date': '掌握日期', 'Review Plan': '复习计划',
  'Total {count} words': '共 {count} 个单词', 'Total {count}': '共 {count} 个', '{count} words': '{count} 个单词',
  'Total {count} words, page {page} of {pages}': '共 {count} 个单词，第 {page}/{pages} 页',
  'Completed {done}/{total}': '已完成 {done}/{total}', 'Done {done}/{total} times': '已完成 {done}/{total} 次',
  'Completed {done}/{total} times': '已完成 {done}/{total} 次', 'Learned {done}/{total}': '已学习 {done}/{total}',
  '{count} times': '{count} 次',
  'Select the wordbooks you want to track for learning. This affects the Word Overview display and statistics.': '选择要追踪学习的词库；这会影响单词总览和统计。',
  'Add Words to Wordbook': '向词库添加单词', 'Manage Words In:': '管理词库单词：',
  'Wordbook Progress': '词库进度', 'No wordbooks available': '暂无可用词库', 'No wordbooks available.': '暂无可用词库。',
  'No wordbooks yet. Click “Create wordbook” in the top right.': '暂无词库，请点击右上角“创建词库”。',
  'No wordbooks yet. Please create one in Secret Wordbook Box.': '暂无词库，请先在私密词库箱中创建。',
  'No wordbooks. Please create one first.': '暂无词库，请先创建一个。', 'No wordbook data.': '暂无词库数据。',
  'Wordbook not found.': '未找到词库。', 'Delete wordbook': '删除词库',
  'This wordbook is managed by teacher; cannot edit or delete': '该词库由教师管理，无法编辑或删除',
  '"My Favorites" cannot be deleted': '“我的收藏”不能删除', 'My Favorites': '我的收藏',
  'From Secret Wordbook:': '来自私密词库：', 'Secret Wordbook:': '私密词库：',
  'Choose from Secret Wordbook Box': '从私密词库箱选择', 'Choose from wordbooks': '从词库选择',
  'Browse all words': '浏览全部单词', 'Words I Mastered': '我已掌握的单词',

  'Assign': '分配', 'Assign Words': '分配单词', 'Assign to Class': '分配给班级',
  'Assign list': '分配列表', 'By Wordbook': '按词库', 'Assignment History': '分配历史',
  'Class Assignment History': '班级分配历史', 'Assigned Date': '分配日期', 'Confirm assignment?': '确认分配吗？',
  'No words selected.': '尚未选择单词。', 'View recent class assignments': '查看近期班级分配',
  'Back to wordbooks': '返回词库', 'Hide already assigned (class representative)': '隐藏已分配单词（以班级代表为准）',
  'Hide words already learned (mastered/to be mastered)': '隐藏已学习单词（已掌握/待掌握）',
  'Clear assigned ({count})': '清空已布置（{count}）',
  'Remove pending teacher-assigned words from this student': '撤销该学生待完成的教师布词',
  'Clear {count} assigned words?': '清空 {count} 个已布置单词？',
  "This removes only pending teacher-assigned words. The student's self-selected and mastered words stay unchanged, and assignment history is preserved.": '只会撤销尚未完成的教师布词。学生自选词和已掌握词不会改变，布置历史也会保留。',
  'Clear {count} words': '清空 {count} 个单词',
  'Clearing…': '正在清空…',
  'Cleared {count} pending assigned words.': '已撤销 {count} 个待完成的布置单词。',
  'Failed to clear assigned words.': '清空已布置单词失败。',
  'Words (comma, space, or newline separated)': '单词（用逗号、空格或换行分隔）',
  'Words (one per line or space-separated)': '单词（每行一个或用空格分隔）',
  'Words (one per line, or space-separated)': '单词（每行一个或用空格分隔）',
  'Add words (one per line or space-separated)': '添加单词（每行一个或用空格分隔）',
  'Enter words (one per line)': '输入单词（每行一个）', 'Words to insert': '要插入的单词',
  'We will keep only words present in the dictionary.': '只会保留词典中已有的单词。',

  'Quiz Management': '测验管理', 'Quiz Library': '测验库', 'Quiz Analytics': '测验分析',
  'Create New Quiz': '创建新测验', 'Quiz Name': '测验名称', 'Quiz Type': '测验类型',
  'Quiz ID': '测验 ID', 'Quiz Details': '测验详情', 'Quiz Data': '测验数据', 'Quiz Performance': '测验表现',
  'Adaptive reading records': '自适应阅读记录',
  'No adaptive reading records yet.': '暂无自适应阅读记录。',
  'The adaptive reading records could not be loaded.': '暂时无法加载自适应阅读记录。',
  'Practice name': '练习名称', 'Delete practice': '删除练习',
  "This deletes the assignment and all of this student's related responses.": '这会取消该学生的布置，并删除这项练习的所有相关作答数据。',
  'Delete this practice? Its recordings and attempts will also be permanently deleted. This cannot be undone.': '删除这项练习？对应的录音和作答记录也会一并永久删除，且无法恢复。',
  'Delete this practice? All related recordings and attempts will also be permanently deleted. This cannot be undone.': '删除这项练习？所有相关录音和作答记录也会一并永久删除，且无法恢复。',
  'Deleting...': '正在删除…', 'Confirm delete': '确认删除',
  'The practice could not be deleted.': '暂时无法删除这项练习。',
  'Not completed': '未完成', 'No completed attempts': '暂无已完成作答',
  'Attempt {number}': '第 {number} 次作答', 'View details': '查看详情',
  'Start Quiz': '开始测验', 'Take': '参加', 'Past Quizzes': '历史测验', 'Pending Quizzes': '待完成测验',
  'Published Quizzes': '已发布测验', 'Recent Quizzes': '近期测验', 'Review Past Quizzes': '复习历史测验',
  'Publish Quiz': '发布测验', 'Publish to Class': '发布到班级', 'Select Class to Publish': '选择发布班级',
  'Choose a class; you can also pick when publishing.': '选择班级；也可以在发布时再选择。',
  'Publish At': '发布时间', 'Publish At (optional)': '发布时间（可选）',
  'Publish At (Shanghai, optional)': '发布时间（上海时间，可选）', 'Published At': '发布时间',
  'Due Date': '截止日期', 'Save as Draft': '保存为草稿', 'Update Published Quiz': '更新已发布测验',
  'Number of Fill-in-the-blank': '填空题数量', 'Number of Sentences': '造句题数量',
  'Section 1: Vocabulary Review': '第一部分：词汇复习', 'Section 2: Fill in the Blank': '第二部分：选词填空',
  'Section 3: Apply Your Knowledge': '第三部分：应用所学', 'Attempt Details': '作答详情',
  'Attempts': '作答次数', 'Review Attempts': '查看作答', 'View Attempt': '查看作答',
  'First Attempt Score': '首次作答分数', 'First Score': '首次分数', 'Latest Score': '最新分数',
  'Final Score': '最终分数', 'Average Score': '平均分', 'Passing Rate': '通过率',
  'Class average (first attempts only):': '班级平均分（仅首次作答）：', 'Based on first attempts': '基于首次作答',
  'Completed Students': '已完成学生', 'Incomplete Students': '未完成学生', 'Completion Rate': '完成率',
  'No attempts': '暂无作答', 'No attempts found for this quiz.': '未找到该测验的作答记录。',
  'No attempt link': '无作答链接', 'No quiz data found.': '未找到测验数据。',
  'No quiz records': '暂无测验记录', 'No recent quizzes available.': '暂无近期测验。',
  'There are no past quizzes to show.': '暂无历史测验。',
  'You are not enrolled in any class. No quizzes are available.': '你尚未加入班级，因此暂无可用测验。',
  'You have completed all available quizzes. Great job!': '你已完成所有可用测验，做得很好！',
  'You have not completed any quizzes yet.': '你还没有完成任何测验。',
  'No detailed records': '暂无详细记录', 'No result found.': '未找到结果。', 'No results found.': '未找到结果。',

  'User Info': '用户信息', 'Nickname:': '昵称：', 'Change Nickname': '修改昵称', 'Update Nickname': '更新昵称',
  'Change Password': '修改密码', 'Confirm Password': '确认密码', 'Security Question': '安全问题',
  'What is your favorite animal?': '你最喜欢的动物是什么？', 'Add Additional Info (Optional)': '添加补充信息（可选）',
  'IELTS speaking coaching preferences': '雅思口语教练偏好',
  'Set the language, target band, and focus for your IELTS Speaking coaching.': '设置雅思口语教练使用的语言、目标分数和反馈重点。',
  'Coach language': '教练语言', 'Chinese': '中文',
  'Choose whether coaching feedback is mainly in Chinese or English.': '选择教练反馈主要使用中文还是英文。',
  'Target IELTS band': '雅思目标分数',
  'Choose a band from 0 to 9 in 0.5 increments.': '请选择 0 至 9 之间、按 0.5 递增的分数。',
  'Coaching preference': '教练偏好',
  'For example: focus on fluency, linking words, and concise corrections.': '例如：重点关注流利度、连接词和简洁纠错。',
  '{count}/200 characters': '已输入 {count}/200 个字符',
  'Save IELTS coaching preferences': '保存雅思口语教练偏好',
  'IELTS coaching preferences saved!': '雅思口语教练偏好已保存！',
  'Set up later': '稍后设置', 'Current time (Asia/Shanghai)': '当前时间（亚洲/上海）',
  'Recent User Logins': '近期用户登录', 'DAU (last 14 days)': '日活跃用户（近 14 天）',
  'Super Admin Overview': '超级管理员总览', 'Teacher Dashboard': '教师首页',

  'No data': '暂无数据', 'No records': '暂无记录', 'No history yet': '暂无历史记录',
  'No pools yet.': '暂无题池。',
  'You haven’t saved any questions yet.': '你还没有收藏任何题目。',
  'Please select': '请选择', '-- Choose --': '-- 请选择 --', 'Cancel and go back': '取消并返回',
  'Skip all (recommended)': '全部跳过（推荐）', 'Select all to include': '全选并纳入',
  'Saturday': '星期六', 'Weekday': '工作日', 'Created at': '创建时间', 'Created:': '创建时间：',
  'Submitted At': '提交时间', 'Last login time': '最后登录时间',
  'Adjust Learning Order': '调整学习顺序', 'Choose wordbook (for supplement)': '选择补充词库',
  'Choose wordbook to supplement (if needed)': '选择补充词库（如需要）',
  'Choose wordbook, count, and difficulty.': '请选择词库、数量和难度。',
  'Class learning goal': '班级学习目标', 'Create Pool': '创建题池', 'Edit description': '编辑说明',
  'Edit Secret Wordbook': '编辑私密词库', 'Enter': '进入',
  'Generate from direct input': '根据直接输入生成', 'Generate from word list': '根据词表生成',
  'Import from .txt': '从 .txt 导入', 'Invite': '邀请', 'Learning Progress': '学习进度',
  'Let’s see which words you already know. This does not affect your final score.': '先看看哪些单词你已经认识；这不会影响最终成绩。',
  'Manage Secret Wordbook Box': '管理私密词库箱', 'Review Progress': '复习进度',
  'Select a student': '选择学生', 'Set class custom wordbooks (multi-select)': '设置班级自定义词库（可多选）',
  'This student currently has no words to master.': '该学生目前没有待掌握单词。',
  'View & Assign': '查看并分配', 'View Details': '查看详情', 'What is the meaning of': '以下内容是什么意思',
  'Your Answer:': '你的答案：', 'Username:': '用户名：',
  'Add Selected': '添加所选', 'Adjust learning order': '调整学习顺序',
  'apple, banana, ... or one per line': 'apple, banana，…或每行一个',
  'Are you sure you want to delete this word?': '确定要删除这个单词吗？',
  'Assign List': '分配列表', 'Assign word to class': '向班级分配单词', 'Assign words': '分配单词',
  'Assigned TBM:': '已分配待掌握词：', 'Back to main menu': '返回主菜单', 'Check': '检查',
  'Confirm Invite': '确认邀请', 'Confirm new password': '确认新密码', 'Confirm password': '确认密码',
  'Back to Student List': '返回学生列表', 'Failed to add student.': '添加学生失败。',
  'Correct answer:': '正确答案：', 'Create new wordbook': '创建新词库', 'Create personal wordbook': '创建个人词库',
  'Current password': '当前密码', 'Daily Learning Goal': '每日学习目标',
  'Default: prioritize assigned words, then supplement with self-study.': '默认优先学习分配单词，再用自主学习内容补足。',
  'Delete this quiz?': '确定删除这个测验吗？', 'Delete this wordbook?': '确定删除这个词库吗？',
  'Delete this wordbook? This action cannot be undone.': '确定删除这个词库吗？此操作无法撤销。',
  'Description': '说明', 'Description (optional)...': '说明（可选）…',
  'Detected ongoing progress. Resume?': '检测到未完成的进度，继续吗？', 'Discard': '放弃',
  'Enter an English word': '输入英文单词', 'Enter answer (used for password recovery)': '输入答案（用于找回密码）',
  'Enter answer (used to recover password)': '输入答案（用于找回密码）', 'Enter class name': '输入班级名称',
  'Enter keyword, press “Search” to start': '输入关键词，点击“搜索”开始', 'Enter new nickname': '输入新昵称',
  'Enter new wordbook name': '输入新词库名称', 'Enter password': '输入密码',
  'Enter student username': '输入学生用户名', 'Enter username': '输入用户名',
  'Example sentences:': '例句：', 'Failed to start learning': '无法开始学习',
  'File columns (header required):': '文件列（必须包含表头）：', 'Fill-in-the-blank sentence': '填空句子',
  'Finish': '完成', 'Finish Preview': '结束预览', 'From Quiz:': '来自测验：',
  'Generate items first': '请先生成题目', 'Go to Login': '前往登录',
  'Great! Now try again without the Chinese hint.': '很好！现在试试不看中文提示再做一次。',
  'Hint for AI (e.g., music, lock)': '给 AI 的提示（例如：music、lock）',
  'I am a self-learning user': '我是自主学习用户', 'I need to link with a teacher': '我需要关联教师',
  'Initial Password': '初始密码', 'Invitation sent': '邀请已发送', 'Creating…': '正在创建…', 'Create Student': '创建学生',
  'It’s likely your last login was too long ago. Please log in again to refresh your session.': '你的登录状态可能已过期，请重新登录以刷新会话。',
  'Learn Now': '立即学习', 'Learn them now': '现在学习', 'Learning goal updated': '学习目标已更新',
  'Listen Again': '再听一次', 'Login as': '以此账户登录',
  'Look up in Cambridge Dictionary': '在剑桥词典中查询', 'Make a sentence using the word:': '请使用这个单词造句：',
  'Manage learning wordbooks': '管理学习词库', 'Meaning': '含义', 'Name cannot be empty': '名称不能为空',
  'New password': '新密码', 'New pool name...': '新题池名称…', 'New word...': '新单词…',
  'Next review': '下次复习', 'Nickname (optional)': '昵称（可选）',
  'No available learning plan: To-be-mastered is empty and today’s goal is met.': '暂无可用学习计划：待掌握列表为空，且今日目标已完成。',
  'No learnable words': '没有可学习的单词', 'No teacher-assigned words to learn': '没有教师分配的待学单词',
  'Open manager': '打开管理器', 'Play pronunciation': '播放发音',
  'Please enter a title or words': '请输入标题或单词', 'Please enter a valid number.': '请输入有效数字。',
  'Please enter at least one word': '请至少输入一个单词', 'Please enter the number of words to learn': '请输入要学习的单词数量',
  'Please enter words': '请输入单词', 'Please request at least one question.': '请至少设置一道题。',
  'Please select a class.': '请选择班级。', 'Please select a word pool.': '请选择词池。',
  'Please select a wordbook': '请选择词库', 'POS (e.g., n.)': '词性（例如 n.）',
  'Preview words to learn': '预览待学单词', 'Provide a username': '请输入用户名',
  'Quiz name is required': '必须填写测验名称', 'Quiz updated': '测验已更新',
  'Remove bookmark': '取消收藏', 'Remove this bookmark?': '确定取消这条收藏吗？',
  'Remove this student?': '确定移除这名学生吗？', 'Remove this word from the wordbook?': '确定从词库中移除这个单词吗？',
  'Review Forecast': '复习预测', 'Save name': '保存名称', 'Search words in current wordbook': '在当前词库中搜索',
  'Search words...': '搜索单词…', 'Select Start Date:': '选择开始日期：',
  'Separate by comma, space, or newline. e.g., apple, banana, ...': '用逗号、空格或换行分隔，例如 apple, banana, …',
  'Set class custom wordbook': '设置班级自定义词库', 'Set from wordbook box': '从词库箱设置',
  'Show private wordbooks': '显示私人词库', 'Skip Audio': '跳过音频', 'Start': '开始',
  'Start learning': '开始学习', 'Start learning selected words': '开始学习所选单词',
  'Student Username': '学生用户名', 'Submit': '提交', 'Tags': '标签',
  'The following words are judged as “mastered” and will be skipped by default. To include any of them in this session, select the corresponding words.': '以下单词被判定为“已掌握”，默认会跳过；如要纳入本次学习，请勾选相应单词。',
  'This wordbook has no available new words': '该词库中没有可用新词', 'Title': '标题',
  'Title cannot be empty': '标题不能为空', 'Today left:': '今日剩余：', 'Type a word...': '输入单词…',
  'Type the spelling and press Enter or Submit': '输入拼写后按 Enter 或点击提交', 'Type the word': '输入单词',
  'Unfinished practice detected. Restore last settings and restart?': '检测到未完成的练习，要恢复上次设置并重新开始吗？',
  'View class stats': '查看班级统计', 'View completion rate': '查看完成率',
  'Want to keep learning? Click': '想继续学习？点击', 'Write your sentence here...': '在这里写句子…',
  'You must include at least one question per word': '每个单词必须至少包含一道题',
  'Authentication not found': '未找到登录信息', 'Authentication not found. Please log in again.': '未找到登录信息，请重新登录。',
  'Class created': '班级已创建', 'Failed to fetch class list': '获取班级列表失败',
  'Failed to fetch class name': '获取班级名称失败', 'Failed to fetch class statistics': '获取班级统计失败',
  'Failed to fetch exam statistics. Please try again later.': '获取测验统计失败，请稍后重试。',
  'Failed to fetch learning data': '获取学习数据失败', 'Failed to fetch mastered words': '获取已掌握单词失败',
  'Failed to fetch the quiz list.': '获取测验列表失败。', 'Failed to fetch wordbooks': '获取词库失败',
  'Failed to fetch words': '获取单词失败', 'Failed to fetch your review list.': '获取复习列表失败。',
  'Failed to fetch your study data.': '获取学习数据失败。', 'Failed to generate items.': '生成题目失败。',
  'Failed to load all words': '加载全部单词失败', 'Failed to load class details.': '加载班级详情失败。',
  'Failed to load quiz': '加载测验失败', 'Failed to load student list.': '加载学生列表失败。',
  'Failed to load students.': '加载学生失败。', 'Failed to load user info.': '加载用户信息失败。',
  'Failed to load wordbook entries': '加载词库条目失败', 'Failed to load wordbooks': '加载词库失败',
  'Failed to load words': '加载单词失败', 'Failed to remove student.': '移除学生失败。',
  'Failed to update tier, please refresh and retry.': '更新等级失败，请刷新后重试。',
  'Goal must be an integer between 0 and 500': '目标必须是 0 到 500 之间的整数',
  'Missing username': '缺少用户名', 'Network response was not ok': '网络响应异常',
  'New password does not match.': '两次输入的新密码不一致。', 'New passwords do not match.': '两次输入的新密码不一致。',
  'Update Password': '更新密码', 'Updating...': '正在更新…', 'Save Answer': '保存答案',
  'Request failed': '请求失败',
  'Coach language must be zh or en.': '教练语言必须是 zh 或 en。',
  'Target IELTS band must be between 0 and 9 in 0.5 increments.': '雅思目标分数必须在 0 至 9 之间，且按 0.5 递增。',
  'Coaching preference must be text with 200 characters or fewer.': '教练偏好必须是 200 个字符以内的文本。',
  'Nickname updated!': '昵称已更新！', 'No result id provided.': '未提供结果 ID。',
  'No token returned': '登录服务未返回凭证', 'No words to practice.': '没有可练习的单词。',
  'Password updated!': '密码已更新！', 'Passwords do not match': '两次输入的密码不一致',
  'Please choose a CSV/XLSX file.': '请选择 CSV/XLSX 文件。', 'Please choose a difficulty level.': '请选择难度等级。',
  'Please enter a class name': '请输入班级名称', 'Please enter a title or word list': '请输入标题或单词列表',
  'Please enter password': '请输入密码', 'Please enter username': '请输入用户名',
  'Please input at least one valid word': '请至少输入一个有效单词', 'Please log in first': '请先登录',
  'Please select at least one student.': '请至少选择一名学生。', 'Please select at least one wordbook': '请至少选择一个词库',
  'Registered successfully. Please log in.': '注册成功，请登录。', 'Rescoring failed': '重新评分失败',
  'Search failed': '搜索失败', 'Security answer updated!': '安全问题答案已更新！',
  'Title saved': '标题已保存', 'TTS request failed': '语音合成请求失败',
  'Unable to load profile.': '无法加载个人资料。',
  'Unrecognized practice mode. Please go back and select again.': '无法识别练习模式，请返回重新选择。',
  'Username and password cannot be empty.': '用户名和密码不能为空。',
  'Students only': '仅学生可访问', 'Authentication required': '请先登录',
  'Invalid username or password': '用户名或密码错误',
  'api.auth.required': '请先登录', 'api.auth.invalid_credentials': '用户名或密码错误',
  'api.auth.students_only': '仅学生可访问', 'api.auth.admin_only': '仅管理员可访问',
  'api.resource.not_found': '未找到请求的内容', 'api.request.invalid_id': 'ID 格式无效',
  'api.request.invalid': '请求无效', 'api.request.missing_fields': '缺少必填字段',
  'api.request.internal_error': '发生错误，请稍后重试', 'api.wordbook.not_found': '未找到词库或无权访问',
  'api.wordbook.teacher_managed': '该词库由教师管理，无法修改', 'api.wordbook.duplicate_title': '已存在同名词库',
  'api.wordbook.created': '词库已创建', 'api.wordbook.updated': '词库已更新', 'api.wordbook.deleted': '词库已删除',
  'api.wordbook.no_valid_words': '提供的单词均不在词典中', 'api.wordbook.no_new_words': '没有可添加的新单词',
  'api.wordbook.words_added': '已添加 {count} 个单词', 'api.wordbook.words_removed': '已移除单词',
  'api.wordbook.capture_settings_failed': '无法加载生词收藏词书。',
  'api.wordbook.capture_invalid_wordbook': '请选择有效的词书。',
  'api.wordbook.capture_wordbook_unavailable': '这个词书无法用于生词收藏。',
  'api.wordbook.capture_default_updated': '默认生词收藏词书已更新。',
  'api.wordbook.capture_invalid_word': '请选择一个英文单词。',
  'api.wordbook.capture_not_in_dictionary': '词源通词典暂未收录这个单词。',
  'api.wordbook.capture_already_saved': '这个单词已经在所选词书中。',
  'api.wordbook.capture_saved': '已将单词加入你的词书。',
  'api.assignment.invalid_target': '班级或学生信息无效。',
  'api.assignment.student_not_in_class': '该学生不属于这个班级。',
  'api.assignment.nothing_to_clear': '没有待清空的教师布词。',
  'api.assignment.concurrent_update': '布词内容刚刚发生变化，请重试。',
  'api.assignment.cleared': '已撤销 {count} 个待完成的布置单词。',
  'api.assignment.activities_preparing': '正在准备练习内容。',
  'api.assignment.activities_failed': '练习内容暂未准备完成，本次没有布置任何内容，请重试。',
  'Word capture': '生词捕捉', 'Word capture: ON': '生词捕捉：开启', 'Word capture: OFF': '生词捕捉：关闭',
  'Turn word capture on': '开启生词捕捉', 'Turn word capture off': '关闭生词捕捉',
  'Loading wordbooks…': '正在加载词书…', 'Word capture is on.': '生词捕捉已开启。',
  'Tap any dotted English word to save it. Turn capture off when you are ready to answer.': '点击带点状下划线的英文词即可收藏；准备答题时请关闭生词捕捉。',
  'Tap a word to save it. Turn capture off to answer the pre-test.': '点击单词即可收藏；关闭生词捕捉后继续预检。',
  'Word capture is on. Tap a word, then turn capture off to continue reordering.': '生词捕捉已开启。点击单词收藏，关闭后继续重组句子。',
  'Add to wordbook': '加入词书', 'Save word': '收藏单词', 'Saving…': '正在保存…',
  'Save "{word}" to a wordbook': '将“{word}”收藏到词书',
  'Save {word} to a wordbook': '将 {word} 收藏到词书',
  'Change the default wordbook from My Wordbooks.': '可在“我的词库”中修改默认词书。',
  'Default word capture wordbook': '默认生词收藏词书',
  'Words captured during practice will start with this wordbook selected.': '练习时收藏生词，将默认选中这本词书。',
  'Save default': '保存默认设置', 'Default quick-save wordbook updated.': '默认生词收藏词书已更新。',
  'Failed to load quick-save wordbooks.': '无法加载生词收藏词书。',
  'Failed to update default wordbook.': '无法更新默认词书。',
  'No editable personal wordbook is available.': '没有可编辑的个人词书。',
  'Could not save this word.': '无法收藏这个单词。',
  'Saved {word} to {wordbook}.': '已将 {word} 收藏到 {wordbook}。',
  '{word} is already in {wordbook}.': '{word} 已经在 {wordbook} 中。',
  'Select one English word.': '请选择一个英文单词。',
  'Please choose a valid wordbook.': '请选择有效的词书。',
  'This wordbook cannot be used for quick save.': '这个词书无法用于生词收藏。',
  'This word is not in the LexiLamp dictionary yet.': '词源通词典暂未收录这个单词。',
  'This word is already in the selected wordbook.': '这个单词已经在所选词书中。',
  'Word saved to your wordbook.': '已将单词加入你的词书。',
  'Dictionary & word capture': '词典与生词收藏',
  'Looking up this word...': '正在查词…',
  'Could not look up this word.': '暂时无法查询这个单词。',
  'Meaning': '释义',
  'Examples': '例句',
  'More dictionary meanings': '更多词典释义',
  'Other meanings': '其他词义',
  '{count} definitions': '{count} 条释义',
  'Synonyms:': '近义词：',
  'No dictionary entry was found for this word.': '没有找到这个单词的词典条目。',
  'Additional definitions from': '补充释义来源：',
  'Free Dictionary API': 'Free Dictionary API',
  'Showing the LexiLamp dictionary.': '当前显示词源通内置词典。',
  'Showing the LexiLamp dictionary.': '当前显示词源通内置词典。',
  'Loading additional dictionary details...': '正在补充更多词典信息…',
  'This word can be looked up, but it is not yet available for LexiLamp wordbooks.': '可以查询这个词，但它暂时还不能加入词源通词书。',
  'This word can be looked up, but it is not yet available for LexiLamp wordbooks.': '可以查询这个词，但它暂时还不能加入词源通词书。',
  'Saving...': '正在保存…',
  'Checking your alternative sentence...': '正在检查你的另一种句子排列…',
  'An AI reviewer is checking grammar, logic, and whether the meaning stays the same.': 'AI 正在检查语法、逻辑以及句意是否保持一致。',
  'Review unavailable — no penalty applied': '暂时无法检查——不会扣除进度',
  'api.class.not_found': '未找到班级', 'api.class.created': '班级已创建', 'api.class.updated': '班级已更新',
  'api.class.deleted': '班级已删除', 'api.student.not_found': '未找到学生', 'api.quiz.not_found': '未找到测验',
  'api.quiz.created': '测验已创建', 'api.quiz.updated': '测验已更新', 'api.quiz.deleted': '测验已删除',
  'api.quiz.published': '测验已发布', 'api.quiz.unpublished': '测验已取消发布',
  'api.quiz.draft_saved': '作业草稿已保存', 'api.operation.success': '操作成功',
  'Not achieved': '未达成', 'Achieved': '已达成', 'Not achieved today': '今日未达成',
  'Achieved today': '今日已达成', 'Sound FX On': '音效已开启', 'Sound FX Off': '音效已关闭',
  'Turn sound effects off': '关闭音效', 'Turn sound effects on': '开启音效',
  'All reviews done 🎉': '所有复习已完成 🎉',
  'Edit Word:': '编辑单词：', 'Teacher:': '教师：', 'Show word': '显示单词', 'Show definition': '显示释义',
  'You will learn': '你将学习', 'to-be-mastered words': '个待掌握单词', ', and': '，以及', 'from': '来自',
  'Exceeds available new words. You can learn at most 0 this time. Starting with available count.': '超出可用新词数量，本次将按实际可用数量开始。',
  '- Attempt Details': '- 作答详情', '- Exam Statistics': '- 测验统计', '- Review': '- 复习',
  'Editing Quiz:': '正在编辑测验：',
  'Daily Practice Report': '每日练习报告',
  'Pre-test, four-step practice, completed vocabulary, and class comparison.': '汇总预检、四步练习、词汇完成情况和班级对比。',
  'Report date': '报告日期',
  'Expand report': '展开报告',
  'Collapse report': '折叠报告',
  'Building daily report...': '正在生成每日练习报告…',
  '{attempts} attempts, {learned} learned, {reviewed} reviewed': '共作答 {attempts} 次，新学 {learned} 个，复习 {reviewed} 个',
  'Pre-test passed': '预检通过',
  'Words learned': '学习词汇数',
  'Words reviewed': '复习词汇数',
  'Average level': '平均学习难度',
  'Not recorded': '暂无记录',
  'No data': '暂无数据',
  'Practice mode': '练习模式',
  'Attempts': '作答次数',
  'Accuracy': '正确率',
  'Infer meaning': '语境推断词义',
  'Definition check': '词义辨认',
  'Sentence reordering': '句子重组',
  'Meaning match': '近义表达匹配',
  'Infer tries': '语境推断次数',
  'Infer accuracy': '语境推断正确率',
  'Definition tries': '词义辨认次数',
  'Definition accuracy': '词义辨认正确率',
  'Reorder tries': '句子重组次数',
  'Reorder accuracy': '句子重组正确率',
  'Match tries': '近义匹配次数',
  'Match accuracy': '近义匹配正确率',
  'Meaning choice tries': '词义选择次数',
  'Meaning choice accuracy': '词义选择正确率',
  'Dictation tries': '听写次数',
  'Dictation accuracy': '听写正确率',
  'Pronunciation tries': '读音训练次数',
  'Pronunciation accuracy': '读音训练正确率',
  'Learning difficulty': '平均学习难度',
  'Class average': '班级平均',
  'Student': '该学生',
  'Class': '班级',
  'Measure': '统计项目',
  'No attempts': '暂无作答',
  'No completed words': '暂无完成词汇',
  '{count} tries': '{count} 次',
  '{count} words': '{count} 个词汇',
  'Tier {tier}': '第 {tier} 级',
  'Counts are scaled per axis; accuracy uses 0-100%. Harder tiers extend farther outward.': '各轴按自身范围缩放；正确率按 0–100% 显示，越靠外代表挑战难度越高。',
  'Session details': '练习明细',
  'Only sessions with recorded activity are shown.': '仅显示当天确实发生作答的练习。',
  'No recorded practice activity on this date.': '当天没有已记录的练习活动。',
  'Advanced': '高级功能',
  'Copy raw daily logs': '复制当天完整日志',
  'Preparing logs...': '正在整理日志…',
  'Copied': '已复制',
  '{count} selected': '已选择 {count} 项',
  'Clear selection': '清除选择',
  'Deadline for selected assignments': '所选任务的截止日期',
  'Apply deadline': '统一修改截止日期',
  'Remove deadline': '设为无截止日期',
  'Remove selected assignments': '删除所选任务',
  'Keep assignments': '保留布置',
  'Completed before': '此前已完成',
  'Tip: hold Shift while selecting to include a continuous range.': '提示：按住 Shift 再勾选，可以连续选择一段任务。',
  'Pending': '待完成',
  'History': '历史记录',
  'Select {word}': '选择 {word}',
  'Deadline for {word}': '{word} 的截止日期',
  'Save deadline': '保存截止日期',
  'Remove assignment': '删除任务',
  'Completed or no longer pending; learning evidence is preserved.': '该任务已完成或已不在待办中，学习记录会继续保留。',
  'Remove {count} pending assignments? Completed learning records will stay unchanged.': '确定删除 {count} 项待完成任务吗？已经产生的学习记录不会被删除。',
  'Could not update these assignments.': '暂时无法更新这些任务。',
  'Assignments updated.': '任务已更新。',
  'Compared with {className} ({count} students).': '与 {className} 班级对比（共 {count} 名学生）。',
  'the class': '本班',
  '{count} active sessions': '{count} 次有效练习',
  'Learning': '学习',
  'Review': '复习',
  '{count} attempts · {accuracy}%': '作答 {count} 次 · 正确率 {accuracy}%',
  'Refresh latest progress': '刷新最新学习进度',
  'Refreshing latest progress...': '正在刷新最新学习进度…',
  'Select {word}: {meaning}': '选择 {word}：{meaning}',
  'Open details for {word}: {meaning}': '查看并设置 {word}：{meaning}',
  'Daily practice radar comparing {student} with the class average': '{student} 与班级平均的每日练习雷达图',
  'the student': '该学生',
  'The list was cleaned to:': '词表已整理为：',
  'Building practice activities': '正在准备练习内容',
  'Check words and meanings': '核对单词和词义',
  'Choose at least one meaning to assign.': '请至少选择一个要布置的词义。',
  'Choose the meanings to teach. Leave every box unchecked to skip a word.': '选择本次要学习的词义；如果不想布置某个词，可以不勾选。',
  'Clear': '清除',
  'Check the words and meanings before assigning. Phrases will be kept together, and possible spelling mistakes will be marked for review.': '布置前先核对单词和词义。短语会保持完整，可能的拼写问题会标出来供你确认。',
  'Checking words and meanings...': '正在核对单词和词义…',
  'Deadline': '截止日期',
  'Difficulty, meanings, and four-step practice activity.': '查看学习难度、具体词义和四步练习情况。',
  'Learn new meanings': '学习新词义',
  'Learning and review period starts': '学习与复习统计起始日',
  'Meaning review progress': '词义核对进度',
  'Mode': '练习类型',
  'new meanings': '个新词义',
  'No new meanings!': '新任务已完成！',
  'No structured study sessions recorded yet. New sessions will appear here.': '暂时没有练习记录。学生开始练习后，记录会显示在这里。',
  'No teacher-assigned meanings to learn': '没有待学习的教师布置词义',
  'Not found in the dictionary': '词典中暂未找到',
  'Nothing will be assigned until these entries are corrected or added.': '请先修正或补充这些内容，再继续布置。',
  'Open assignments without a deadline are not counted as overdue.': '没有截止日期的任务会保持开放，不会计为逾期。',
  'Paste the list as you have it, then check the words and meanings.': '直接粘贴现有词表，然后核对单词和词义。',
  'Practice activity generation': '练习内容准备进度',
  'Practice activity generation is taking longer than expected. Please try again.': '练习内容准备时间较长，请稍后重试。',
  'Practice activity preparation': '练习内容准备进度',
  'Preparing the practice activities is taking longer than expected. Please try again.': '练习内容准备时间较长，请稍后重试。',
  'Primary': '主要词义',
  'Reading the list and checking meanings...': '正在整理词表并核对词义…',
  'Result': '结果',
  'Retry': '重试',
  'Review vocabulary meanings': '核对词义',
  'Select any meanings, or leave all unchecked to skip this word.': '选择要布置的词义；全部不选即可跳过这个词。',
  'Show teacher words due on or before': '显示在所选日期或之前到期的教师布词',
  'Skipped': '已跳过',
  'Step': '练习步骤',
  'Study Sessions': '练习记录',
  'Suggested correction:': '建议改为：',
  'Support': '辅助信息',
  'Teacher-added': '教师添加',
  'Teacher-assigned meanings (priority)': '教师布置词义（优先学习）',
  'This looks like a possible typo, so it has not been selected.': '这个词可能有拼写问题，暂未选中。',
  'This looks like a possible typo, so it will be skipped unless you retry it.': '这个词可能有拼写问题；如果不重试，会自动跳过。',
  'Use correction': '使用建议修正',
  'This retry is taking longer than expected. Its result is still saved.': '本次重试需要更长时间，结果仍会保留。',
  'Try the unfinished entries again before assigning.': '请先重试未完成的项目，再继续布置。',
  'Word / meaning': '单词 / 词义',
  'Copy every practice record for this student on the selected date as structured data.': '复制该学生在所选日期的全部练习记录，方便进一步分析。',
  'New practice activities are needed': '需要准备新的练习内容',
  'This word is not in the dictionary yet': '词典暂未收录这个词',
  'Reorder the following sentence:': '请重新排列下面的句子：',
  'Show Chinese translation': '显示中文翻译',
  'Hide Chinese translation': '隐藏中文翻译',
  'Show Chinese': '显示中文',
  'Hide Chinese': '隐藏中文',
  'No Chinese hint available': '这道题暂时没有中文提示',
  'AI hint': 'AI 提示',
  'Ask the AI coach for a hint': '向 AI 教练获取提示',
  'AI sentence coach': 'AI 句子教练',
  'Looking at your sentence...': '正在分析你目前的拼法……',
  'Ask a follow-up question': '继续追问',
  'Ask about the grammar or word order': '追问语法或语序',
  'Ask a question, or send blank for the next hint': '可以继续提问，或直接发送以获取下一步提示',
  'Send question or get next hint': '发送问题或获取下一步提示',
  'Now use the guidance and try the sentence yourself.': '现在请根据提示，自己完成这道题。',
  '{count} follow-up questions left': '还可以追问 {count} 次',
  'Great! Now rebuild it once without hints.': '很好！现在不看任何提示，再完整拼一次。',
  'AI coach is unavailable right now.': 'AI 教练暂时无法回答。',
  'AI sentence hint': 'AI 句子提示',
  'Initial guidance': '首次提示',
  'Follow-up {number}': '第 {number} 次追问',
  'Current arrangement': '当前拼法',
  'Student question': '学生提问',
  'Coach reply': '教练回复',
  'AI Usage Ledger': 'AI 用量总账',
  'Token costs only. Prompts, answers, images, and audio are not stored.': '仅记录 Token 成本，不保存提示词、回答、图片或音频。',
  'Usage month': '用量月份',
  'Refreshing...': '正在刷新...',
  'Actual AI cost': 'AI 实际成本',
  'Students with recorded usage': '有用量记录的学生',
  'Active budget accounts': '有效额度账户',
  'Cost by student': '按学生查看成本',
  'Student': '学生',
  'Requests': '请求数',
  'Cost': '成本',
  'Cost by feature and model': '按功能和模型查看成本',
  'Feature': '功能',
  'Model': '模型',
  'No recorded student usage this month.': '本月暂无学生 AI 用量记录。',
  'No AI usage recorded this month.': '本月暂无 AI 用量记录。',
  'Failed to load AI usage': '无法载入 AI 用量记录',
  'Allowance status': '额度状态',
  'Not set': '未建立额度账户',
  'Tokens': 'Token 用量',
  'All monthly allowances': '全部月度额度',
  'Account': '账户',
  'Used': '已使用',
  'Reserved': '已预留',
  'Monthly limit': '月度上限',
  'Help assistant': 'AI 客服',
  'Fill-in-the-blank practice': '填空练习',
  'Quiz feedback': '测验反馈',
  'Sentence coach': '句子教练',
  'Sentence answer review': '句子答案复核',
  'Speech playback': '语音播放',
  'Structured content generation': '结构化内容生成',
  'Teacher content generation': '教师内容生成',
  'Word practice generation': '词汇练习生成',
  'Tidying an assignment list': '整理教师词表',
  'Reading an assignment list': '识别教师词表',
  'Other AI work': '其他 AI 功能',
  'requests': '次业务请求',
  'provider calls': '次模型调用',
  'input': '输入',
  'cached': '缓存命中',
  'output': '输出',
  'thinking': '思考',
  'Student account': '学生账户',
  'Institution account': '机构账户',
  'Within allowance': '额度正常',
  'Needs attention': '需要留意',
  'Near monthly limit': '接近月度上限',
  'Monthly limit reached': '已达月度上限',
  'Status unavailable': '状态暂不可用',
  'Assign practice': '分配练习',
  'Quiz list': '测验列表',
  'Quiz assignments': '测验任务',
  'Preparing': '生成中',
  'Assigned': '已布置',
  'Updates automatically': '自动更新',
  'No quizzes are being prepared.': '目前没有正在生成的测验。',
  'No quizzes have been assigned yet.': '目前还没有已布置的测验。',
  'Not attempted': '尚未作答',
  '{count} completed attempts': '已完成 {count} 次',
  'View': '查看',
  'Remove assignment': '删除布置',
  'Confirm remove': '确认删除',
  'Removing...': '正在删除…',
  'Assignment removed': '已删除布置',
  'The student will no longer see this assignment. Existing attempt records will be kept.': '删除后学生将不再看到这份任务，已经产生的作答记录会继续保留。',
  'The quiz list could not be loaded.': '暂时无法读取测验列表。',
  'The assignment could not be removed.': '暂时无法删除这份布置。',
  'The quiz could not be found.': '找不到这份测验。',
  'Assigning...': '分配中…',
  'Preparing the first draft': '正在准备初稿',
  'The first draft is ready': '初稿已完成',
  'Checking the questions and difficulty': '正在检查题目与难度',
  'The review is ready': '检查已完成',
  'Finishing the practice': '正在完成练习',
  'Practice assigned': '练习已分配',
  'Practice preparation started': '已开始准备练习',
  'The practice could not be assigned. Please try again.': '暂时无法分配这份练习，请重试。',
  'Practice name': '练习名称',
  'optional': '可选',
  'Use the generated article title': '使用生成的文章标题',
  'Use the student’s recent learning and review history.': '使用该学生近期的学习和复习记录。',
  'Use words learned or reviewed today.': '使用该学生今天学习或复习过的词。',
  'Use the exact material from the latest completed session.': '使用最近一次完整学习中的词汇和练习记录。',
  'Follow IELTS Academic reading structure and question standards.': '遵循雅思学术类阅读的结构和出题标准。',
  'Target this student’s vocabulary, errors, and current learning level.': '针对该学生的词汇、错误和当前学习水平。',
  'Reading the student’s learning record': '正在读取学生的学习记录',
  'Planning the passage and questions': '正在设计文章和题目',
  'Checking evidence and answers': '正在核对证据和答案',
  'Saving the practice assignment': '正在保存练习任务',
  'You can leave this window open while the article is checked and saved.': '文章正在核验并保存，请保持此窗口打开。',
  'Preparing and assigning the reading practice': '正在生成并分配阅读练习',
  'This may take a few minutes. The practice will appear in the student’s quiz list after it is ready.': '生成可能需要几分钟；完成后，练习会出现在学生的测验列表中。',
  'Preparing and assigning...': '正在生成并分配…',
  'Generate and assign': '生成并分配',
  'Reading practice assigned: {name}': '已分配阅读练习：{name}',
  'The reading could not be prepared yet. Please try again.': '暂时无法生成这篇阅读，请重试。',
  'This student needs a little more recorded vocabulary practice for that scope.': '该范围内的学习记录还不够，请先让学生完成一些词汇练习。',
  'My quizzes and reading': '我的测验与阅读',
  'Teacher assignments and your saved reading practice are kept together here.': '教师布置的任务和已保存的阅读练习都会保留在这里。',
  'To do': '待完成',
  'Completed and saved': '已完成与已保存',
  'Could not load your assigned practice.': '无法加载已分配的练习。',
  'Loading practice...': '正在加载练习…',
  'Open result or practice again': '查看结果或重新练习',
  'Continue': '继续',
  'Start': '开始',
  'No assigned practice is waiting for you.': '目前没有待完成的练习。',
  'Completed practice will appear here.': '完成的练习会保留在这里。',
  'You are not enrolled in a class yet.': '你暂时还没有加入班级。',
  'Opening a new attempt...': '正在打开新的练习…',
  'Practice this article again': '重新练习这篇文章',
  'Reading result': '阅读结果',
  'Quiz result': '测验结果',
  'Practice result': '练习结果',
  'Time used': '用时',
  'Completed at': '完成时间',
  'Read the passage again': '重新查看文章',
  'Question review': '逐题回顾',
  'Show All': '显示全部',
  'Show Incorrect Only': '只看错题',
  'Your answer': '你的答案',
  'Correct answer': '正确答案',
  'Evidence': '文中依据',
  'Why': '解析',
  'No answer': '未作答',
  'AI Feedback': 'AI 反馈',
  'Rescoring...': '正在重新评分…',
  'Rescore': '重新评分',
  'Working...': '正在处理…',
  'Unbookmark': '取消收藏',
  'Bookmark': '收藏',
  'My Lists': '我的词单',
  'Personal vocabulary': '个人词汇',
  'Save exact meanings, organize them, and choose which lists support your learning.': '按精确词义保存和整理，并选择哪些词单参与后续学习。',
  'Folders': '词夹',
  'Folder': '词夹',
  'Folder name': '词夹名称',
  'New folder': '新建词夹',
  'Rename folder': '重命名词夹',
  'Archive folder': '归档词夹',
  'Archive this folder? Lists inside it will be hidden.': '归档这个词夹吗？其中的词单将被隐藏。',
  'Lists': '词单',
  'New list': '新建词单',
  'List name': '词单名称',
  'Rename list': '重命名词单',
  'Archive list': '归档词单',
  'Archive this list?': '归档这个词单吗？',
  'No lists in this folder yet.': '这个词夹里还没有词单。',
  'Add meanings': '添加词义',
  'Add meanings to this list': '向词单添加词义',
  'Create a vocabulary list': '新建词单',
  'Choose the exact meanings you want to keep.': '选择需要保留的准确词义。',
  'Words or words with meanings': '单词或带释义的单词',
  'Only meanings already available in the public dictionary can be saved.': '只能保存公共词库中已有的词义。',
  'No matching public meaning was found. This entry will be skipped.': '没有找到匹配的公共词义，将跳过这一项。',
  'No vocabulary entries were found.': '没有识别到词汇。',
  'Save selected meanings': '保存所选词义',
  'Move to folder': '移动到词夹',
  'Quick-save destination': '快速收藏位置',
  'New words you save quickly will go to this list.': '练习中快速收藏的单词会进入这个词单。',
  'Use for personal practice': '用于个性化练习',
  'Let this list contribute vocabulary to your future practice.': '让这个词单为后续个性化练习提供词汇。',
  'This list is empty. Add the first meaning when you are ready.': '这个词单还是空的，可以从添加第一个词义开始。',
  'Choose a list to see its meanings.': '选择一个词单查看其中的词义。',
  'Mastered': '已掌握',
  'Review due': '待复习',
  'Learning': '学习中',
  'Not started': '未开始',
  'Assign vocabulary': '分配词汇',
  'Assign vocabulary to {name}': '给 {name} 分配词汇',
  'Only this student will receive the assignment. Teaching lists remain reusable.': '本次任务只会发给这名学生，教学词单仍可继续复用。',
  'Recent assignments for this student': '这名学生最近的布置记录',
  'Reuse a teaching list or review new vocabulary before assigning it.': '复用教学词单，或先核对新词汇再布置。',
  'Assign': '布置',
  'History': '历史',
  'From teaching lists': '从教学词单选择',
  'Paste new vocabulary': '粘贴新词汇',
  'New teaching folder': '新建教学词夹',
  'Teaching folder name': '教学词夹名称',
  'Choose the exact meanings for this assignment.': '选择本次要布置的准确词义。',
  'Check words and meanings': '核对单词和词义',
  'What should happen after review?': '核对后要做什么？',
  'Assign now': '直接布置',
  'Give these exact meanings to the class.': '把这些准确词义直接布置给班级。',
  'Create list and assign': '新建词单并布置',
  'Keep a reusable teaching list and assign it now.': '保存为可复用的教学词单，并立即布置。',
  'Add to a list and assign': '追加到词单并布置',
  'Append new meanings to an existing teaching list, then assign.': '把新词义追加到已有教学词单，然后布置。',
  'Save as teaching list': '只保存教学词单',
  'Keep the reviewed meanings for later without assigning them.': '保存核对后的词义供以后使用，本次不布置给学生。',
  'Teaching folder': '教学词夹',
  'Teaching list': '教学词单',
  'New list name': '新词单名称',
  'Choose a list': '选择词单',
  'Edit input': '修改输入',
  'Choose a folder and give the list a name.': '请选择词夹并填写词单名称。',
  'Choose a teaching list.': '请选择教学词单。',
  'Recent class assignments': '最近的班级布置',
  'No history yet.': '暂无历史记录。',
  'Archive this teaching folder and its lists?': '归档这个教学词夹及其中词单吗？',
  'Archive this teaching list?': '归档这个教学词单吗？',
  'Create empty list': '创建空词单',
  'Give this list a name.': '请填写词单名称。',
  'This list could not be checked.': '暂时无法核对这份词单，请稍后重试。',
  'Could not save these meanings.': '暂时无法保存这些词义，请稍后重试。',
  'For example: Reading mistakes': '例如：阅读错词',
  'Saved': '已保存',
  'Preparing...': '正在准备…',
  'Done.': '已完成。',
  'Assignment failed.': '布置未完成，请重试。',
  'Check meanings': '核对词义',
  'Checking meanings...': '正在核对词义…',
  'Choose at least one meaning.': '请至少选择一个词义。',
  'Clear all': '全部取消',
  'Could not load your lists.': '暂时无法加载词单，请稍后重试。',
  'Enter at least one word.': '请至少输入一个单词。',
  'For example: Unit 3 vocabulary': '例如：第三单元词汇',
  'No deadline': '不设截止日期',
  'This entry is still being checked.': '这一项仍在核对中，请稍候。',
  'Please enter a name.': '请输入名称。',
  'This change could not be saved.': '暂时无法保存这项更改，请稍后重试。',
  'Save changes': '保存更改',
  'Create folder': '创建词夹',
  'Archive': '归档',
  'Archive teaching folder': '归档教学词夹',
  'Archive teaching list': '归档教学词单',
  '{count} lists': '{count} 个词单',
  '{count} meanings': '{count} 个词义',
  '{count} exact meanings': '{count} 个准确词义',
  '{count} meanings selected': '已选择 {count} 个词义',
  'Assign {count} meanings': '布置 {count} 个词义',
  'Continue with {count} meanings': '继续处理 {count} 个词义',
  'Saved {count} exact meanings to the teaching list.': '已将 {count} 个准确词义保存到教学词单，本次没有布置给学生。',
  '{count} meanings are ready; {failed} need another try.': '已有 {count} 个词义准备完成，另有 {failed} 个需要重试。',
  '{count} meanings are ready for students.': '已有 {count} 个词义可供学生学习。',
  'Assigned {date}': '布置于 {date}',
  'Due {date}': '截止于 {date}',
  'Preparing word audio': '正在准备单词读音',
  'Tap words to listen': '点词听音',
  'Tap any word in the sentence to hear it.': '点击句中任意单词即可听发音。',
  'Play this word': '播放这个单词',
  'Waiting': '待进入',
  'Practice another card while one is being scored. Each sentence must pass on its own.': '一张卡等待评分时，可以继续练另外两张；每个句子都需要独立通过。',
  'Confirm and continue': '确认并换下一句',
  'Confirm when you are ready for the next sentence.': '看完反馈后确认，这张卡会换入下一句。',
  'You can practise either of the other cards now.': '评分期间可以先练另外两张卡。',
  'Preparing practice audio': '正在准备练习读音',
  'You can start at any time. Audio continues preparing in the background.': '可以随时开始，读音会继续在后台准备。',
  'Pronunciation Practice': '读音训练',
  'Listen to a short sentence, read it aloud, and get focused feedback on whether the target word is clear.': '先听一遍短句，再朗读并获得针对目标词清晰度的反馈。',
  '{count} sentences ready': '已准备 {count} 个句子',
  'Read short Tier 6 sentences and check whether each target word is clear.': '朗读基础档短句，检查目标词是否清楚易懂。',
  'Selected activities will open in order with the same words.': '所选练习会使用同一批词，依次打开。',
  'Start selected practice': '开始所选练习',
  'Listen once, then read the sentence aloud. A clear target word matters most.': '先听一遍，再朗读整句；最重要的是把目标词读清楚。',
  'Replay sentence': '重播句子',
  'Listen again': '再听一次',
  'Listen to my recording': '重听我的录音',
  'Start recording': '开始录音',
  'Finish recording': '结束录音',
  'Scoring your reading...': '正在分析朗读…',
  'Try once more': '再试一次',
  'Clarity': '清晰度',
  'Target word': '目标词',
  'Completeness': '完整度',
  'Rhythm': '节奏',
  'Record again': '重新录音',
  'Practice later': '稍后再练',
  'Next sentence': '下一句',
  'What to fix': '需要修正的地方',
  'See results': '查看结果',
  'No pronunciation sentences are ready for this set yet.': '这批词暂时没有可用的读音训练句。',
  'Recording is not supported in this browser.': '当前浏览器不支持录音。',
  'Microphone access is needed for pronunciation practice.': '读音训练需要麦克风权限。',
  'Your recording could not be scored right now': '暂时无法分析这段录音，请稍后重试。',
  'Your progress could not be saved. Please try again.': '暂时无法保存学习进度，请重试。',
  'My Practices': '我的练习',
  'My practices': '我的练习',
  'Review history': '复习记录',
  'Your completed teacher-assigned practice and earlier quizzes are kept here.': '教师布置练习和以往测验的完成记录都会保存在这里。',
  'Assigned practice': '教师布置练习',
  'Review the exact meanings, latest result, and practice again when needed.': '查看练习使用的准确词义和最近成绩，需要时可以再次练习。',
  'Open My Practices': '打开我的练习',
  'No completed assigned practice yet.': '还没有已完成的教师布置练习。',
  'Past quizzes': '历史测验',
  'Open an earlier quiz to review each saved attempt.': '打开历史测验，查看每一次保存的作答。',
  'No past quizzes yet.': '还没有历史测验。',
  'Loading review history...': '正在加载复习记录…',
  'Review history could not be loaded.': '暂时无法加载复习记录。',
  'Some review history could not be loaded.': '部分复习记录暂时无法加载，其余记录仍可查看。',
  'Some assigned practice could not be loaded.': '部分待完成练习暂时无法加载，其余练习仍可继续。',
  '{count} attempts': '{count} 次作答',
  'Last on {date}': '最近完成于 {date}',
  'Teacher assignments and independent practice stay together here.': '教师布置的练习和自主练习记录都会显示在这里。',
  '{count} exact meanings': '{count} 个准确词义',
  '{count} independent practice records are available in your history.': '历史中有 {count} 条自主练习记录。',
  'In progress': '进行中',
  'Overdue': '已逾期',
  'Upcoming': '即将开放',
  'Completed': '已完成',
  'Not started': '未开始',
  'Start practice': '开始练习',
  'Practice again': '再练一次',
  'Could not load your assigned practice.': '暂时无法加载布置给你的练习。',
  'This practice is not ready yet.': '这项练习还没有准备好。',
  'This practice opens later.': '这项练习稍后开放。',
  'This practice has no vocabulary meanings yet': '这项练习暂时没有词汇词义。',
  'The practice could not be opened.': '暂时无法打开这项练习。',
  'The speaking session could not be found.': '找不到这次口语练习，请重新打开。',
  'This IELTS speaking practice could not be found.': '找不到这项雅思口语练习，请返回“我的练习”重新打开。',
  'Also assign practice': '同时布置练习',
  'These practices use the exact meanings you just confirmed.': '这些练习会使用你刚刚确认的准确词义。',
  'Assign practice': '布置练习',
  'Assign practice to class': '向班级布置测验',
  'Whole class: {name}': '全班：{name}',
  'Practice': '练习',
  'Strengthen spelling and meaning together.': '结合拼写和词义进行巩固。',
  'Build quick meaning recall.': '训练快速辨认词义。',
  'Build speed and steady recall.': '提升反应速度和稳定记忆。',
  'Read short sentences and make the target word clear.': '朗读短句，练习把目标词读清楚。',
  'Transfer recent vocabulary into reading context.': '把近期词汇放入阅读语境中练习。',
  'Assign selected practice': '布置所选练习',
  'The practice could not be assigned.': '暂时无法布置练习。',
  'Choose at least one practice.': '请至少选择一项练习。',
  '{count} practices assigned.': '已布置 {count} 项练习。',
  'Practice name': '练习名称',
  'Deadline': '截止时间',
  'Available from': '开放时间',
  'Reading mode': '阅读模式',
  'Vocabulary scope': '词汇范围',
  'The student list is frozen at the moment you assign this practice.': '练习布置时会冻结学生名单。',
  'For example: Unit 4 practice': '例如：第四单元练习',
  'Student practices': '学生练习',
  'View report': '查看报告',
  'The practice list could not be loaded.': '暂时无法加载练习列表。',
  'The practice could not be removed.': '暂时无法移除这项练习。',
  'No assigned practice yet.': '暂时没有布置练习。',
  'Back to attempts': '返回作答记录',
  'Back to practice': '返回练习',
  'View all attempts': '查看全部作答',
  'View details': '查看详情',
  'All attempts': '全部作答',
  'Attempt': '作答',
  'Attempt {number}': '第 {number} 次作答',
  'First attempt': '首次作答',
  'Submitted': '已提交',
  'completed': '已完成',
  'Try again': '重试',
  'Loading practice result...': '正在加载练习结果…',
  'Loading practice reports...': '正在加载练习报告…',
  'Practice history': '练习记录',
  'View every saved attempt for this assigned practice.': '查看这项布置练习保存的全部作答。',
  'No attempts found for this practice.': '这项练习还没有作答记录。',
  'Attempt pagination': '作答记录分页',
  'You do not have access to this practice.': '你无权查看这项练习。',
  'You do not have access to this practice result.': '你无权查看这项练习结果。',
  'This practice result was not found.': '没有找到这项练习结果。',
  'The practice history could not be loaded.': '暂时无法加载练习记录。',
  'The practice result could not be loaded.': '暂时无法加载练习结果。',
  'Assignment report': '练习报告',
  'Assigned practice reports': '布置练习报告',
  'Open one assignment to review completion and first-attempt results.': '打开一项练习，查看完成情况和首次作答结果。',
  'No assigned practice reports yet.': '暂时没有布置练习报告。',
  'All assigned practices and saved attempts for this class appear here.': '这个班级的全部布置练习和已保存作答都会显示在这里。',
  'Only whole-class assignments': '只显示向全班布置的练习',
  'Practice type': '练习类型',
  'Audience': '布置对象',
  'Whole class': '全班',
  'Individual students': '单个学生',
  'Legacy quiz': '旧版测验',
  'Open for details': '打开查看',
  'Completion: {rate}% ({completed}/{total})': '完成率：{rate}%（{completed}/{total}）',
  'Completed students ({count})': '已完成学生（{count}）',
  'Pending students ({count})': '待完成学生（{count}）',
  'No students have completed this practice yet.': '还没有学生完成这项练习。',
  'No pending students.': '没有待完成学生。',
  'Open an attempt to review its saved result and details.': '打开单次作答，查看已保存的结果和详情。',
  'Open full report': '打开完整报告',
  '{count} attempts': '{count} 次作答',
  'Detailed metrics are shown inside this assignment report.': '具体指标会在这项练习报告中展示。',
  'First-attempt accuracy': '首次作答正确率',
  'First-attempt sample size': '首次作答样本数',
  'First-attempt aggregates only · sample size {count}': '仅统计首次作答 · 样本数 {count}',
  'The practice reports could not be loaded.': '暂时无法加载练习报告。',
  'Spelling and meaning outcomes': '拼写和词义结果',
  'Meaning result': '词义结果',
  'Meaning answers': '词义作答',
  'Lightning result': '闪电挑战结果',
  'Round and item outcomes': '轮次和题目结果',
  'Pronunciation result': '读音训练结果',
  'Pronunciation outcomes': '读音训练结果',
  'Reading summary': '阅读总结',
  'Needs retry': '需要重试',
  'No item outcomes were saved.': '没有保存题目结果。',
  'No pronunciation item outcomes were saved.': '没有保存读音题目结果。',
  'No reading questions were saved.': '没有保存阅读题目。',
  'Not available': '暂无',
  'Retry items': '重试题目',
  'Answer': '答案',
  'Timeouts': '超时次数',
  'Response time': '反应时间',
  'Passed items': '通过题目',
  'Total items': '题目总数',
  'Pass groups': '通过轮次',
  'Not passed': '未通过',
  'Passed on attempt {count}': '第 {count} 次通过',
  'Standard audio': '标准音频',
  'Student recording': '学生录音',
  'Earlier failed recordings': '之前未通过的录音',
  'Failed recording': '未通过录音',
  'Questions': '题目数',
  'ms': '毫秒',
  'AI review': 'AI 复核',
  'Available': '可用',
  'The practice was assigned, but the attached practice could not be prepared.': '词汇已布置，但附加练习暂时无法准备。',
  'Add vocabulary meanings for these practices, or use the vocabulary assignment flow first.': '请为这些练习添加词汇词义，或先使用词汇布置流程确认准确词义。',
  'Vocabulary source': '词汇来源',
  'One word per line': '每行一个单词。',
  'Leave this empty for adaptive reading from recent history. For exact meanings, the vocabulary assignment flow is recommended.': '留空时，自适应阅读会使用最近学习记录；准确词义建议先通过词汇布置流程确认。',
  'Leave this empty for adaptive reading or IELTS Speaking. For exact meanings, the vocabulary assignment flow is recommended.': '自适应阅读或雅思口语可以留空；准确词义建议先通过词汇布置流程确认。',
  'For exact meanings, the vocabulary assignment flow is recommended.': '如需布置准确词义，建议使用词汇布置流程。',
  'Search teaching lists': '搜索教学词单',
  'Search by list name': '按词单名称搜索',
  'Page {page} of {pages}': '第 {page} / {pages} 页',
  'Previous page': '上一页',
  'Next page': '下一页',
  'No teaching lists yet.': '还没有教学词单。',
  'No teaching lists match your search.': '没有符合搜索条件的教学词单。',
  'No lists match your search.': '没有符合搜索条件的词单。',
  'Submission History': '提交记录',
  ', self-study': '，自主学习',
  '% completed by this date': '% 已在此日期前完成',
  '← Back': '← 返回',
  '← Back to all classes': '← 返回所有班级',
  '← Back to Class Details': '← 返回班级详情',
  '← Back to Teacher Dashboard': '← 返回教师中心',
  'Assigned meanings': '已布置词义',
  'Auto audio:': '自动播放：',
  'Available meanings:': '可用词义：',
  'Average Score:': '平均分：',
  'Combined': '合并',
  'Completed (': '已完成（',
  'completed words': '个已完成单词',
  'Completion:': '完成率：',
  'correct attempts': '次答对',
  'Count (max:': '数量（最多：',
  'Current default:': '当前默认：',
  'Current order:': '当前顺序：',
  'Current Streak:': '当前连续记录：',
  'entries': '项',
  'need correction': '项需要修正',
  'need new practice activities': '项需要生成新练习',
  'need retry': '项需要重试',
  'Not Completed (': '未完成（',
  'Flashcard': '闪卡',
  'invitations from teachers': '来自教师的邀请',
  'Learned in Secret Wordbook (': '已从私密词库学习（',
  'Line': '第',
  'meanings': '个词义',
  'Other Learned Words (': '其他已学习单词（',
  'Pass Rate:': '通过率：',
  'Priority wordbook:': '优先词库：',
  'Review Today': '今日复习',
  'recorded': '已记录',
  'Saved at:': '保存时间：',
  'Selected:': '已选择：',
  'Self-study (': '自主学习（',
  'Sentence Reordering Error Log (': '句子重组错误记录（',
  'sentences scored': '句已评分',
  'still being prepared for this level, so the closest available exercise level will be used.': '仍在准备该等级的练习，将使用最接近的可用等级。',
  'students': '名学生',
  'Students may choose this level or any more challenging level.': '学生可以选择此等级或更高难度的等级。',
  'Students:': '学生数：',
  'Study Details': '学习详情',
  'To-be-mastered Words (': '待掌握单词（',
  'Today (': '今日（',
  'Type:': '类型：',
  'Words Reviewed Today (': '今日复习单词（',
  'You have': '你有',
  'You have {count} invitations from teachers': '你有 {count} 个来自教师的邀请',
  'Priority wordbook: {title} ({count})': '优先词库：{title}（{count}）',
  'Assigned ({count})': '已布置（{count}）',
  'Self-study ({count})': '自主学习（{count}）',
  'Count (max: {count})': '数量（最多：{count}）',
  'Auto audio: {state}': '自动播放：{state}',
  'ON': '开启',
  'OFF': '关闭',
  'Level {level}': '等级 {level}',
  'Flashcard {current}/{total}': '闪卡 {current}/{total}',
  'Section {number}: {title}': '第 {number} 部分：{title}',
  'Working...': '处理中……',
  'Unsave Vocab': '移出词汇收藏',
  'Save Vocab': '保存到词汇收藏',
  'Error:': '错误：',
  's': '秒',
  'One word is still being prepared for this level, so the closest available exercise level will be used.': '还有 1 个单词正在准备该等级的练习，将使用最接近的可用等级。',
  '{count} words are still being prepared for this level, so the closest available exercise level will be used.': '{count} 个单词仍在准备该等级的练习，将使用最接近的可用等级。',
  'Assigned meanings {assigned}, self-study {selfStudy}': '已布置词义 {assigned} 个，自主学习 {selfStudy} 个',
  'Assigned Words To Learn ({count})': '待学习单词（{count}）',
  'Attempt on {time}': '作答时间：{time}',
  'Students ({count})': '学生（{count}）',
  '{type} Quiz': '{type} 测验',
  'Quiz': '测验',
  'Comprehensive training': '综合训练',
  'Meaning training': '词义训练',
  'Hear, identify, spell, and say each meaning.': '听音、辨义、拼写，并朗读每个词义。',
  'Build reading meaning through context and guided practice.': '通过语境和引导练习建立阅读词义。',
  'No meanings are available for this mode.': '此模式暂无可用词义。',
  'Training mode': '训练模式',
  'Batch training mode': '批次训练模式',
  'Learning mode': '学习模式',
  'Review mode': '复习模式',
  'Step {step} of 4': '第 {step} 步，共 4 步',
  'Step {step} of 3': '第 {step} 步，共 3 步',
  'Meaning choice': '选择词义',
  'Listen and identify': '听音辨义',
  'Listen and spell': '听音拼写',
  'Listen, spell, and identify': '听音拼写与辨义',
  'Pronunciation practice': '读音训练',
  'Read aloud': '朗读',
  'Step 1: Choose the meaning': '第 1 步：选择词义',
  'Step 2: Listen and identify': '第 2 步：听音辨义',
  'Step 3: Listen and spell': '第 3 步：听音拼写',
  'Step 4: Read aloud': '第 4 步：朗读',
  'Step 2: Listen, spell, and identify': '第 2 步：听音拼写与辨义',
  'Step 3: Pronunciation practice': '第 3 步：读音训练',
  'Practice up to three sentences together': '同时练习最多三个句子',
  'While one sentence is being scored, you can record another card. A failed word returns to step 1.': '一个句子评分时，可以继续录制另一张卡；未通过的词会回到第 1 步。',
  'Return this word to step 1': '让这个词回到第 1 步',
  'Ready to re-learn!': '准备好再次巩固!',
  'Play recording': '播放录音',
  'Playing recording...': '正在播放录音...',
  'This recording could not be played.': '暂时无法播放这段录音。',
  'View pronunciation details': '查看读音详情',
  'Choose the accurate meaning for this word.': '请选择这个单词对应的准确词义。',
  'The spelling is hidden. Listen, then choose the meaning.': '拼写会隐藏。请先听音，再选择词义。',
  'Play word': '播放单词',
  'Listen again, type the spelling, and choose its meaning.': '再听一次，输入拼写并选择对应的词义。',
  'Type the spelling': '输入拼写',
  'Choose the matching meaning': '选择匹配的词义',
  'Listen to the sentence': '听句子',
  'A score of 70 or above passes this step.': '分数达到 70 分或以上即可通过此步骤。',
  'This meaning returns to step 1.': '这个词义会回到第 1 步。',
  'Reinforce from step 1': '从第 1 步巩固',
  'No meanings are ready for comprehensive training.': '暂无可用于综合训练的词义。',
  'Group {group} of {groups}': '第 {group} 组，共 {groups} 组',
  '{done}/{total} meanings completed': '已完成 {done}/{total} 个词义',
  'Preparing audio for this group': '正在准备本组音频',
  'Preparing remaining audio': '正在准备剩余音频',
  'Preview the words; four listening and speaking steps start next.': '预览词汇；接下来会开始四步听说训练。',
  'Preview the words; three listening and speaking steps start next.': '预览词汇；接下来会开始三步听说训练。',
  'Choose quantity, training mode, and difficulty before starting.': '开始前请选择数量、训练模式和难度。',
  'meanings ready in this mode': '此模式可学习词义',
  'available in this mode': '此模式可复习',
  'Choose difficulty, training mode, and amount': '请选择难度、训练模式和数量',
  'IELTS Speaking Practice': '雅思口语练习',
  'Record one answer, get a predicted band, and keep coaching history.': '录制一次回答，查看预测分，并保留连续教练反馈记录。',
  'IELTS speaking settings': '雅思口语设置',
  'Speaking question': '口语题目',
  'Leave empty for a general speaking assessment.': '留空表示一般口语能力评估。',
  'Part': 'Part',
  'Part 1': 'Part 1',
  'Part 2': 'Part 2',
  'Part 3': 'Part 3',
  'Part {part}': 'Part {part}',
  'Not specified': '未指定',
  'Suggested answer time': '建议回答时长',
  '15 to 300 seconds': '15 至 300 秒',
  'Target band': '目标分数',
  'Target band {band}': '目标 {band} 分',
  'The result will show whether the student reached this predicted band.': '完成后会显示学生是否达到这个预测分数。',
  'Target reached': '完成并达标',
  'Target not reached': '完成但未达标',
  'Target not reached yet': '尚未达标',
  'No target score': '未设置目标分数',
  'IELTS speaking quizzes': '雅思口语测验',
  'Loading IELTS speaking quizzes...': '正在加载雅思口语测验…',
  'No IELTS speaking quizzes yet.': '还没有雅思口语测验。',
  'The IELTS speaking records could not be loaded.': '暂时无法加载雅思口语测验。',
  'Completion': '完成状态',
  'Goal': '目标状态',
  'Not completed': '未完成',
  '{count} recordings': '{count} 条录音',
  'Loading recordings...': '正在加载录音…',
  'No recordings yet.': '还没有录音。',
  'The IELTS speaking recordings could not be loaded.': '暂时无法加载雅思口语录音。',
  'Recording {number}': '第 {number} 次录音',
  'Score pending': '等待评分',
  'Loading recording details...': '正在加载作答详情…',
  'The recording details could not be loaded.': '暂时无法加载这次作答详情。',
  '{count} students reached the target': '{count} 名学生已达标',
  '{count} students completed below the target': '{count} 名学生已完成但未达标',
  'Strict timer': '严格计时',
  'Soft timer': '软计时',
  'Stop the microphone automatically at the suggested time.': '到达建议时长后自动停止麦克风。',
  'Both question and Part can be empty. The student will see a general speaking assessment and no question will be generated.': '题目和 Part 都可以留空；学生会看到一般口语能力评估，系统不会自动生成题目。',
  'Both question and Part can be empty. No question will be generated.': '题目和 Part 都可以留空，系统不会自动生成题目。',
  'General speaking assessment': '一般口语能力评估',
  'Prompt-based assessment': '基于题目的评估',
  'No prompt supplied; speak about a topic you choose.': '未提供题目，请选择一个话题作答。',
  'Speak about a topic you choose. No question will be generated.': '请自行选择一个话题作答，系统不会自动生成题目。',
  'Prompt provided': '已提供题目',
  'Part not specified': '未指定 Part',
  'Assessment scope': '评估范围',
  'Start IELTS speaking practice': '开始雅思口语练习',
  'New speaking practice': '新建口语练习',
  'Back to My Practices': '返回我的练习',
  'Teacher assignment': '教师布置',
  'Loading IELTS speaking practice...': '正在加载雅思口语练习…',
  'The new speaking thread could not be created.': '无法创建新的口语练习线程。',
  'The next speaking attempt could not be started.': '无法开始下一次口语练习。',
  'Ready to record': '准备录音',
  'Requesting microphone access...': '正在请求麦克风权限…',
  'Recording': '录音中',
  'Suggested time reached; you can continue.': '已达到建议时长，可以继续录音。',
  'Strict timer reached; saving your recording.': '严格计时已到，正在保存录音。',
  'Uploading recording...': '正在上传录音…',
  'Recording uploaded. AI scoring is in progress.': '录音已上传，AI 正在评分…',
  'Assessment complete': '评分完成',
  'Fresh grading in progress...': '正在进行本次独立评分…',
  'Preparing continuous coaching...': '正在准备连续教练反馈…',
  'This recording can be retried.': '这段录音可以重试评分。',
  'The IELTS speaking request failed.': '雅思口语请求失败，请稍后重试。',
  'The IELTS speaking assessment was incomplete. Retry scoring.': '本次评分结果不完整，请重新评分。',
  'Start recording': '开始录音',
  'Stop and submit': '停止并提交',
  'Continue recording': '继续录音',
  'Retry scoring': '重试评分',
  'This browser does not support microphone recording.': '当前浏览器不支持麦克风录音。',
  'Microphone access was not granted.': '未获得麦克风权限。',
  'You can request the microphone again when ready.': '准备好后可以再次请求麦克风权限。',
  'Your IELTS speaking result': '你的雅思口语结果',
  'IELTS speaking history': '雅思口语历史',
  'Every attempt stays available with its score and answer details.': '每次作答都会保留分数和作答详情。',
  'IELTS speaking sessions': '雅思口语练习记录',
  'Each session keeps its own attempts and coaching context.': '每轮练习分别保留自己的作答和教练反馈上下文。',
  'No IELTS speaking sessions yet.': '还没有雅思口语练习记录。',
  'Session {number}': '第 {number} 轮练习',
  'Continue this session': '继续这一轮',
  'Choose a session to continue, or open an earlier attempt to review its recording, score, and feedback.': '选择一轮继续练习，或打开过去的作答查看录音、分数和反馈。',
  'band change': '分变化',
  'Latest': '最新',
  'Attempt {number}': '第 {number} 次作答',
  'IELTS speaking result': '雅思口语结果',
  'IELTS speaking assessment': '雅思口语评估',
  'Predicted band': '预测分',
  'Fluency and coherence': '流利度与连贯性',
  'Lexical resource': '词汇资源',
  'Grammatical range and accuracy': '语法范围与准确性',
  'Pronunciation': '发音',
  'Why this band': '评分依据',
  'No written rationale was returned.': '本次没有返回文字评分依据。',
  'Coach feedback': '教练反馈',
  'Progress': '进步',
  'Keep building a clear, complete answer.': '继续组织清晰、完整的回答。',
  'Priority issue': '首要问题',
  'No priority issue was returned.': '本次没有返回首要问题。',
  'Next steps': '下一步',
  'Repeat the answer once with one more supporting detail.': '再答一次，并补充一个支持细节。',
  'Practice action': '具体练习动作',
  'Record the same answer again and focus on the priority issue.': '再次录制同一道题，集中解决首要问题。',
  'My recording': '我的录音',
  'Play my recording': '播放我的录音',
  'The recording is not available for playback.': '本次录音暂不可播放。',
  'Your browser cannot play this recording.': '你的浏览器无法播放这段录音。',
  'Teacher reports use the first attempt as the aggregate baseline.': '教师报告使用首次作答作为汇总基准。',
  'IELTS first-attempt snapshot': 'IELTS 首次作答概览',
  'Authentic mode reads each question aloud, plays a reminder sound, gives ten seconds to turn on the microphone, and stops each answer at the official practice limit.': '\u4eff\u771f\u6a21\u5f0f\u4f1a\u9010\u9898\u8bfb\u9898\uff0c\u8fdb\u5165\u5f00\u9ea6\u7a97\u53e3\u65f6\u64ad\u653e\u63d0\u9192\u97f3\uff0c\u7559\u51fa 10 \u79d2\u5f00\u542f\u9ea6\u514b\u98ce\uff0c\u5e76\u5728\u4f5c\u7b54\u65f6\u9650\u5230\u8fbe\u65f6\u81ea\u52a8\u505c\u6b62\u3002',
  'Practice mode': '\u7ec3\u4e60\u6a21\u5f0f',
  'Custom practice': '\u81ea\u5b9a\u4e49\u6a21\u5f0f',
  'Add a speaking question.': '\u8bf7\u8f93\u5165\u4e00\u9053\u53e3\u8bed\u9898\u76ee\u3002',
  'Enter one speaking question': '\u8f93\u5165\u4e00\u9053\u53e3\u8bed\u9898\u76ee',
  'The student sees the question and can turn on the microphone at any time.': '\u5b66\u751f\u4f1a\u76f4\u63a5\u770b\u5230\u9898\u76ee\uff0c\u5e76\u53ef\u4ee5\u968f\u65f6\u5f00\u542f\u9ea6\u514b\u98ce\u3002',
  'The examiner reads this question aloud, then the student has ten seconds to turn on the microphone.': '考官会先朗读这道题，随后学生有 10 秒时间开启麦克风。',
  'Custom simulation uses strict timing and the examiner reads the question aloud before recording.': '自定义仿真使用严格计时，开始作答前考官会先朗读题目。',
  'Leave blank to generate a name from the question or cue-card topic.': '\u7559\u7a7a\u65f6\uff0c\u5c06\u6839\u636e\u9898\u76ee\u6216\u9898\u5361\u4e3b\u9898\u81ea\u52a8\u751f\u6210\u540d\u79f0\u3002',
  'Simulation section': '\u4eff\u771f\u90e8\u5206',
  'Part 1 interview': 'Part 1 \u9762\u8bd5',
  'Part 2 cue card + Part 3 discussion': 'Part 2 \u9898\u5361 + Part 3 \u8ba8\u8bba',
  'Part 1 questions': 'Part 1 \u95ee\u9898',
  'One question per line': '\u6bcf\u884c\u4e00\u9053\u95ee\u9898',
  'Each answer can end early and is cut off after 60 seconds.': '\u6bcf\u9898\u53ef\u63d0\u524d\u7ed3\u675f\uff0c60 \u79d2\u65f6\u81ea\u52a8\u622a\u6b62\u3002',
  'Part 2 cue-card topic': 'Part 2 \u9898\u5361\u4e3b\u9898',
  'Cue-card points': '\u9898\u5361\u63d0\u793a\u70b9',
  'One point per line': '\u6bcf\u884c\u4e00\u4e2a\u63d0\u793a\u70b9',
  'Short Part 2 follow-ups': 'Part 2 \u7b80\u77ed\u8ffd\u95ee',
  'Part 3 follow-up mode': 'Part 3 \u8ffd\u95ee\u6a21\u5f0f',
  'Ask all teacher questions': '\u8be2\u95ee\u5168\u90e8\u6559\u5e08\u9898\u76ee',
  'Randomly ask two teacher questions': '\u968f\u673a\u62bd\u53d6\u4e24\u9053\u6559\u5e08\u9898\u76ee',
  'Automatic examiner follow-up': '\u81ea\u52a8\u8003\u5b98\u8ffd\u95ee',
  'Automatic examiner follow-ups are generated from the student’s real answer during the simulation. No seed question is needed.': '自动考官会在仿真过程中根据学生的真实回答即时生成追问，不需要预设引导题。',
  'Part 3 questions': 'Part 3 \u95ee\u9898',
  'optional seed': '\u53ef\u9009\u5f15\u5bfc\u9898',
  'The question order and random selection are frozen for each attempt so a resumed attempt stays consistent.': '\u6bcf\u6b21\u4f5c\u7b54\u7684\u9898\u76ee\u987a\u5e8f\u4e0e\u968f\u673a\u7ed3\u679c\u90fd\u4f1a\u51bb\u7ed3\uff0c\u6062\u590d\u540e\u4ecd\u4fdd\u6301\u4e00\u81f4\u3002',
  'Add at least one Part 1 question.': '\u8bf7\u81f3\u5c11\u6dfb\u52a0\u4e00\u9053 Part 1 \u95ee\u9898\u3002',
  'Add the Part 2 cue-card topic.': '\u8bf7\u6dfb\u52a0 Part 2 \u9898\u5361\u4e3b\u9898\u3002',
  'Add at least one Part 3 follow-up question.': '\u8bf7\u81f3\u5c11\u6dfb\u52a0\u4e00\u9053 Part 3 \u8ffd\u95ee\u3002',
  'Authentic IELTS speaking simulation': '\u771f\u5b9e IELTS \u53e3\u8bed\u4eff\u771f',
  'Part 2 + Part 3': 'Part 2 + Part 3',
  'Questions are read aloud one at a time. After each question, a reminder sound plays and you have ten seconds to click the microphone. You may stop early; the timer cuts off the answer at the practice limit.': '\u7cfb\u7edf\u4f1a\u9010\u9898\u8bfb\u9898\u3002\u6bcf\u6b21\u8bfb\u5b8c\u540e\u4f1a\u64ad\u653e\u63d0\u9192\u97f3\uff0c\u8bf7\u5728 10 \u79d2\u5185\u70b9\u51fb\u9ea6\u514b\u98ce\u3002\u53ef\u63d0\u524d\u7ed3\u675f\uff0c\u5230\u65f6\u4f1a\u81ea\u52a8\u622a\u6b62\u3002',
  'Questions are read aloud one at a time. The examiner voice, natural pauses, and your answers are kept together in one interview recording. After each question, you have ten seconds to turn on the microphone.': '题目会由考官逐题朗读；考官声音、自然停顿和你的回答会一起保存在一段完整的面试录音中。每次读题后，你有 10 秒时间开启麦克风。',
  '{count} examiner turns in this attempt.': '\u672c\u6b21\u5171 {count} \u4e2a\u8003\u5b98\u56de\u5408\u3002',
  'Two Part 3 questions will be generated live from your answers.': '系统会根据你的回答即时生成两道 Part 3 追问。',
  'Part 2 includes one minute of preparation and up to two minutes to speak.': 'Part 2 \u5305\u542b 1 \u5206\u949f\u51c6\u5907\u65f6\u95f4\u548c\u6700\u591a 2 \u5206\u949f\u4f5c\u7b54\u65f6\u95f4\u3002',
  'Begin simulation': '\u5f00\u59cb\u4eff\u771f',
  'Preparing the interview recording...': '正在准备整场面试录音…',
  'Question {current} of {total}': '\u7b2c {current}/{total} \u9898',
  'Examiner is reading the question...': '\u8003\u5b98\u6b63\u5728\u8bfb\u9898\u2026\u2026',
  'Preparation time': '\u51c6\u5907\u65f6\u95f4',
  'Use this minute to make brief notes. Recording has not started.': '\u7528\u8fd9 1 \u5206\u949f\u5199\u7b80\u77ed\u7b14\u8bb0\uff0c\u5f55\u97f3\u5c1a\u672a\u5f00\u59cb\u3002',
  'Use this minute to make brief notes. Your answer microphone is not active yet.': '请用这一分钟做简短笔记；用于回答的麦克风尚未开启。',
  'Turn on the microphone now': '\u73b0\u5728\u5f00\u542f\u9ea6\u514b\u98ce',
  'The reminder sound has played. Click within ten seconds.': '\u63d0\u9192\u97f3\u5df2\u64ad\u653e\uff0c\u8bf7\u5728 10 \u79d2\u5185\u70b9\u51fb\u3002',
  'Turn on microphone': '\u5f00\u542f\u9ea6\u514b\u98ce',
  'Finish this answer': '\u7ed3\u675f\u672c\u9898\u4f5c\u7b54',
  'The ten-second microphone window was missed. Moving to the next question.': '\u5df2\u9519\u8fc7 10 \u79d2\u5f00\u9ea6\u7a97\u53e3\uff0c\u5373\u5c06\u8fdb\u5165\u4e0b\u4e00\u9898\u3002',
  'Moving to the next question...': '\u6b63\u5728\u8fdb\u5165\u4e0b\u4e00\u9898\u2026\u2026',
  'The examiner is preparing a follow-up from your answer...': '考官正在根据你的回答准备追问…',
  'Your answer segment is used only to generate this live question; the segment is not stored separately.': '这一小段回答仅用于即时生成追问，不会被单独长期保存。',
  'The live follow-up could not be prepared.': '暂时无法生成即时追问。',
  'Retry follow-up': '重试追问',
  'Finish simulation now': '立即结束仿真',
  'The AI follow-up is temporarily unavailable. Retry this question.': 'AI 追问暂时不可用，请重试本轮追问。',
  'This browser cannot mix the examiner voice into the recording. Your microphone answer will still be saved.': '当前浏览器无法把考官声音混入录音，但你的麦克风回答仍会正常保存。',
  'One examiner prompt could not be mixed into the recording; playback continued.': '有一道考官题目未能混入录音，但读题与练习已继续。',
  'Try microphone again': '\u91cd\u8bd5\u9ea6\u514b\u98ce',
  'Keep this page open while the attempt is submitted.': '\u63d0\u4ea4\u671f\u95f4\u8bf7\u4fdd\u6301\u672c\u9875\u6253\u5f00\u3002',
  'Restart simulation': '\u91cd\u65b0\u5f00\u59cb\u4eff\u771f',
  'Strict timing is active for this simulation.': '\u672c\u6b21\u4eff\u771f\u5df2\u542f\u7528\u4e25\u683c\u8ba1\u65f6\u3002',
  'No answer was recorded. Start the simulation again.': '\u6ca1\u6709\u5f55\u5230\u4f5c\u7b54\uff0c\u8bf7\u91cd\u65b0\u5f00\u59cb\u4eff\u771f\u3002',
  'No answer was recorded for the follow-up.': '没有录到可用于生成追问的回答。',
  'Authentic simulation complete': '\u4eff\u771f\u5df2\u5b8c\u6210',
  '{answered} answered, {missed} missed microphone windows.': '\u5df2\u4f5c\u7b54 {answered} \u9898\uff0c\u9519\u8fc7\u5f00\u9ea6\u7a97\u53e3 {missed} \u6b21\u3002',
  '1 answer': '1 次回答',
  '20 min': '20 分钟',
};

export const patternsZhCN = [
  [/^Loading (.+)\.\.\.$/, '正在加载 $1…'],
  [/^(\d+) words?$/, '$1 个单词'],
  [/^Total (\d+) words?$/, '共 $1 个单词'],
  [/^Total (\d+)$/, '共 $1 个'],
  [/^Total (\d+) words?, page (\d+) of (\d+)$/, '共 $1 个单词，第 $2/$3 页'],
  [/^(?:Done|Completed) (\d+)\/(\d+) times$/, '已完成 $1/$2 次'],
  [/^Learned (\d+)\/(\d+)$/, '已学习 $1/$2'],
  [/^(\d+) times$/, '$1 次'],
  [/^(\d+) students?$/, '$1 名学生'],
  [/^(\d+) attempts?$/, '$1 次作答'],
  [/^Page (\d+) of (\d+)$/, '第 $1 页，共 $2 页'],
  [/^Step (\d+) of (\d+)$/, '第 $1 步，共 $2 步'],
  [/^Added (\d+) words?$/, '已添加 $1 个单词'],
  [/^Selected: (\d+)$/, '已选择：$1'],
  [/^Score: (.+)$/, '分数：$1'],
  [/^Welcome, (.+)!$/, '欢迎，$1！'],
  [/^One-click Learn \((\d+) left\)$/, '一键学习（剩余 $1 个）'],
  [/^One-click Review \((\d+) left\)$/, '一键复习（剩余 $1 个）'],
  [/^Completed today’s learning — learned (\d+) words$/, '今日学习已完成——已学习 $1 个单词'],
  [/^Completed today's learning — learned (\d+) words$/, '今日学习已完成——已学习 $1 个单词'],
  [/^Exceeds available new words\. You can learn at most (\d+) this time\. Starting with available count\.$/, '超出可用新词数量，本次最多可学习 $1 个，将按实际可用数量开始。'],
];
